export default {
  // Sidebar
  appTitle: 'Terminus',
  newThesis: 'New Solution Line',
  addThesis: 'Add Solution Line',
  titlePlaceholder: 'Solution line title',
  descriptionPlaceholder: 'Brief description of your solution line',
  cancel: 'Cancel',
  add: 'Add',
  confirmDelete: 'Confirm Delete',
  deleteThesisQuestion: 'Are you sure you want to delete this solution line?',
  deleteAction: 'Delete',
  done: 'done',
  thesisCreated: 'New Solution Line Created',
  thesisAdded: 'Solution Line Added',
  thesisAddedDesc: 'Your new solution line has been added successfully.',
  
  // Chat
  markDone: 'Mark refining as done',
  refinementComplete: 'Refinement complete',
  typePlaceholder: 'Enter feedback to refine solutions...',
  connected: 'Connected',
  disconnected: 'Disconnected',
  newMessage: 'New Message',
  generatedSolutions: 'Generated Solutions',
  refineSolutions: 'Refine Solutions',
  refineShort: 'Refine',
  refiningSolutions: 'Refining Solutions',
  refiningSolutionsDesc: 'Your feedback is being used to refine the research solutions.',
  send: 'Send',
  regularMessage: 'Regular Message',
  error: 'Error',
  unknownError: 'An unknown error occurred',
  
  // Status
  status: {
    draft: 'Draft',
    submitted: 'Submitted',
    in_progress: 'In Progress',
    running: 'Running',
    done: 'Completed',
    published: 'Published',
    completed: 'Completed',
    validated: 'Validated',
    waiting_validation: 'Waiting Validation',
    rejected: 'Rejected',
    in_committee: 'In Committee',
    approved: 'Approved',
    has_project: 'Has Project',
    closed: 'Closed',
    failed: 'Failed',
    tooltips: {
      draft: 'Draft - Awaiting processing',
      submitted: 'Submitted - Awaiting review',
      in_progress: 'In Progress - Processing',
      running: 'Running - Currently processing',
      done: 'Completed - Done',
      published: 'Published - Visible to applicants',
      completed: 'Completed',
      validated: 'Validated - Ready for use',
      in_committee: 'In Committee - Under review',
      approved: 'Approved',
      has_project: 'Has Project - Project generated',
      closed: 'Closed',
      failed: 'Failed - Encountered an error',
    },
  },
  
  // Actions
  actions: {
    edit: 'Edit',
    cancel: 'Cancel',
    processFiles: 'Process Files',
    viewDetails: 'View Details',
    viewReport: 'View Report',
    download: 'Download',
    generateBrief: 'Generate Brief',
  
    preparingDownload: 'Preparing PDF...',
    unlink: 'Unlink',
    open: 'Open',
    downloadPdf: 'Download PDF',
    openFile: 'Open file',
    remove: 'Remove',
    openInNewTab: 'Open in new tab',},

  roles: {
    entrepreneur: 'entrepreneur',
  },
  
  // Filters
  opportunityStages: {
    draft: 'Draft',
    pending: 'Pending',
    inCommittee: 'In Committee',
    approved: 'Approved',
    inAssembly: 'In Assembly',
    inLead: 'In Lead',
    hasProject: 'Has Project',
    rejected: 'Rejected',
  },
  filters: {
    vertical: 'Vertical',
    selectVertical: 'Select vertical',
    allVerticals: 'All Verticals',
    enterprise: 'Enterprise',
    consumer: 'Consumer',
    b2b: 'B2B',
    b2c: 'B2C',
    dateRange: 'Date Range',
    selectDateRange: 'Select date range',
    allTime: 'All Time',
    lastWeek: 'Last Week',
    lastMonth: 'Last Month',
    lastQuarter: 'Last Quarter',
    lastYear: 'Last Year',
    resetFilters: 'Reset Filters',
  
    clear: 'Clear filters',
    type: 'Type',
    sector: 'Sector',
    urgency: 'Urgency',
    urgencyOptions: {
      any: 'Any urgency',
      critical: 'Critical',
      high: 'High',
      medium: 'Medium',
      low: 'Low',
      none: 'No urgency',
    },
    none: 'No filters configured.',
    regulatory: 'Regulatory',
    sourceType: 'Source',
    technology: 'Technology',
    horizon: 'Horizon',
    region: 'Region',
    sortBy: 'Sort by',
    sort: 'Sort',
    sortOptions: {
      newest: 'Newest first',
      oldest: 'Oldest first',
      titleAsc: 'Name A → Z',
      titleDesc: 'Name Z → A',
      urgencyDesc: 'Highest urgency',
      solutionsDesc: 'Most solutions',
      priorityDesc: 'Highest priority',
      priorityAsc: 'Lowest priority',
      applicantsDesc: 'Most applicants',
      filesDesc: 'Most files',
      opportunitiesDesc: 'Most opportunities',
    },
  },

  // Discovery (review queue)
  discovery: {
    title: 'discovery',
    subtitle: 'Emerging startups surfaced by daily source monitoring.',
    items: 'items',
    empty: 'Nothing to show.',
    view: 'View',
    filters: 'Filters',
    filtersStatus: 'Status',
    filtersKind: 'Kind',
    filtersSector: 'Sector',
    filtersSource: 'Source',
    clearFilters: 'Clear all filters',
    search: 'Search discoveries...',
    kindNew: 'new',
    kindTracked: 'tracked',
    statusPending: 'Pending',
    statusApproved: 'Approved',
    statusRejected: 'Rejected',
    approve: 'approve',
    dismiss: 'dismiss',
    ingestingTitle: 'Ingesting {{name}}',
    approveSuccess: 'Approved {{name}} — generating profile',
    approveError: 'Failed to approve',
    dismissSuccess: 'Dismissed {{name}}',
    dismissError: 'Failed to dismiss',
    viewInDealflow: 'view in dealflow',
    companyIdentity: 'company',
    noSummary: 'No summary available.',
    generating2D: 'generating 2D analysis…',
    problemMarket: 'problem & market',
    businessExecution: 'business & execution',
    source: 'source',
    origin: 'origin',
    article: 'article',
    sourceArticle: 'source article',
    discovered: 'discovered',
    location: 'location',
    stats: {
      total: 'Total',
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
    },
    sort: {
      label: 'Sort by',
      newest: 'Newest first',
      oldest: 'Oldest first',
      nameAsc: 'Name A → Z',
      nameDesc: 'Name Z → A',
    },
    date: {
      label: 'Date',
      all: 'All time',
      today: 'Today',
      yesterday: 'Yesterday',
      last3: 'Last 3 days',
      thisWeek: 'This week',
      lastWeek: 'Last week',
      lastMonth: 'Last month',
    },
  },

  // WebSocket
  connecting: 'Connecting...',
  connectionError: 'Connection Error',
  
  // Report
  reportTitle: 'Report',
  generatedReport: 'Generated report based on your refinement',
  exportPDF: 'Export PDF',
  shareReport: 'Share Report',
  
  // Welcome screen
  welcome: 'Welcome to Terminus',
  selectThesis: 'Select an existing solution line from the sidebar or create a new one to get started with refining your ideas.',
  noTheses: 'No solution lines yet. Click the + button in the sidebar to add your first solution line.',

  // Notifications
  thesisDeleted: 'Solution line deleted',
  thesisDeletedDesc: 'Your solution line has been removed.',
  refinementCompleted: 'Refinement complete',
  refinementCompletedDesc: 'Your solution line is now being processed. The report will be ready shortly.',

  // Notification System
  notifications: {
    title: 'Notifications',
    bell: 'Notifications',
    markAllRead: 'Mark all read',
    empty: 'No notifications yet',
    viewAll: 'View all notifications',
    pageTitle: 'Notifications',
    allNotifications: 'All Notifications',
    unread: 'Unread',
    read: 'Read',
    markAsRead: 'Mark as read',
    markAllAsRead: 'Mark all as read',
    noNotifications: 'No notifications',
    noNotificationsDesc: "You're all caught up! No new notifications.",
    noUnread: 'No unread notifications',
    noUnreadDesc: "You've read all your notifications.",
    filterByType: 'Filter by type',
    allTypes: 'All types',
    types: {
      system_alert: 'System Alert',
      action_required: 'Action Required',
      info: 'Information',
      application_status: 'Application Status',
      project_match: 'Project Match',
      committee_assignment: 'Committee Assignment',
    },
    priority: {
      high: 'High',
      medium: 'Medium',
      low: 'Low',
    },
  
    tabs: {
      all: 'All',
      unread: 'Unread',
    },
    refresh: 'Refresh',},
  
  // Theme and Language
  theme: 'Theme',
  language: 'Language',
  light: 'Light',
  dark: 'Dark',
  system: 'System',
  english: 'English',
  spanish: 'Spanish',

  // Thesis Actions
  thesisActions: {
    addSolution: 'Add Solution',
    addSolutionTooltip: 'Add a new solution manually',
    generateSingleSolution: 'Generate Single Solution',
    generateSingleSolutionTooltip: 'Generate a single solution using AI',
    generateSolutionsBulk: 'Generate Solutions in Bulk',
    generateSolutionsBulkTooltip: 'Generate multiple solutions using AI',
    generateReport: 'Generate Report',
    generateReportTooltip: 'Generate a report for this solution line'
  },

  // NotFound page
  notFound: {
    404: '404',
    pageNotFound: 'page not found.',
    description: 'the page you are looking for does not exist or has been moved.',
    goBack: 'go back',
    returnHome: 'return home',
  },

  // Error handling
  errors: {
    generic: 'Something went wrong',
    validationError: 'Invalid data submitted',
    notFound: 'The requested resource was not found',
    unauthorized: 'Please log in to continue',
    forbidden: "You don't have permission to access this",
    serverError: 'Server Error',
    serverErrorMessage: "We're experiencing technical difficulties. Our team has been notified.",
    applicationError: 'Application Error',
    applicationErrorMessage: 'Something went wrong in this browser. Please try again.',
    badRequest: 'Invalid request',
    conflict: 'This operation conflicts with existing data',
    serviceUnavailable: 'Service temporarily unavailable',
    networkError: 'Network error',
    checkConnection: 'Please check your internet connection',
    tryAgain: 'try again',
    goHome: 'go home',
    supportReference: 'Reference: {{requestId}}',
    opportunityNotFound: 'Opportunity not found',
    saveFailed: 'Failed to save changes',
  },

  // CreateThesisForm
  createThesisForm: {
    thesisTitle: 'Solution Line Title',
    enterThesisTitle: 'Enter solution line title',
    titleRequired: 'Solution line title cannot be empty',
    creating: 'Creating...',
    createThesis: 'Create Solution Line',
  },

  // CreateMarketInsightForm
  createMarketInsightForm: {
    title: 'Create Market Insight',
    nameLabel: 'Name',
    namePlaceholder: 'Enter market insight name',
    categoryLabel: 'Category',
    categoryPlaceholder: 'Select a category',
    createButton: 'Create Market Insight',
    fillAllFields: 'Please fill in all fields',
    created: 'Market insight created successfully',
    createFailed: 'Failed to create market insight',
  
    sectorPlaceholder: 'Select a sector',
    sectorLabel: 'Category',},

  // Categories
  categories: {
    all: 'All',
    // Sector labels come from /api/sectors (display_name field), not from
    // the locale file. The only keys retained here are the meta-options
    // ("All", "Industry Category" header) that have no backend equivalent.
    industryCategory: 'Industry Category',
  },

  // MarketInsightTable
  marketInsightTable: {
    name: 'Name',
    status: 'Status',
    created: 'Created',
    theses: 'Solution Lines',
    opportunities: 'Opportunities',
    fileName: 'File Name',
    actions: 'Actions',
    searchPlaceholder: 'Search market insights...',
    noInsightsFound: 'No market insights found',
    noFiles: 'No files',
  },

  marketInsight: {
    downloadingBrief: 'Preparing the brief...',
    regenerate: 'Regenerate',
    files: 'Files',
    opportunities: 'Opportunities',
    references: 'References',
    referencesTitle: 'References',
    comprehensiveReport: 'Comprehensive Report',
    metadata: 'Metadata',
    aiGenerated: 'AI Generated',
    sectionSources: 'Sources for this section',
    allReferences: 'All References',
    contents: 'Contents',
    citations: 'Citations',
    noBriefYet: 'No brief generated yet',
    runGenerateToCreate: 'Run the generator from the header to produce the brief.',
    primaryResearch: 'Primary research',
    primaryResearchDesc: '{{count}} source document(s) uploaded for analysis.',
    noWebSources: 'No web sources cited.',
    viewFullBibliography: 'View full bibliography ({{count}})',
    unnamedStartup: 'Unnamed startup',
    generatingOpportunityFrom: 'Generating opportunity from {{name}}…',
    generateOpportunityFailed: 'Failed to generate opportunity',
    removeMatchFailed: 'Failed to remove startup',
    matchItemType: 'match',
    matchedStartups: 'Matched startups',
    addStartup: 'Add startup',
    matchingInProgress: 'Matching startups...',
    noMatchedStartups: 'No matched startups yet.',
    manuallyAdded: 'Manually added',
    createOpportunity: 'create opportunity',
    startupAttached: 'Startup added to matches',
    startupsAttached: '{{count}} startups added to matches',
    startupAttachFailed: 'Failed to attach {{count}} startup(s)',
    attachFailed: 'Failed to attach startup',
    attachPickerTitle: 'Add startups to matches',
    createNewStartup: 'Create new startup',
    sectionLabels: {
      introduccion_ejecutiva: 'Introduction',
      macrotendencias: 'Macro Trends',
      retos_estructurales: 'Challenges',
      problemas_empresa: 'Problems',
      tecnologias_emergentes: 'Technologies',
      prioridades_inversion: 'Investment',
      relevancia_region: 'Relevance',
      benchmark_china: 'China Benchmark',
    },
  
    referenceCount: '{{count}} references',
    fileCount: '{{count}} files',
    viewReferences: 'View references ({{count}})',
    viewFilters: 'View filters',
    viewFiles: 'View files ({{count}})',
    briefComplete: 'Brief complete',
    noReferences: 'No references yet — generate the brief to populate this list.',
    referencesSidebarTitle: 'References',
    filtersSidebarTitle: 'Analysis filters',
    noFiles: 'No files uploaded for this market insight.',
    filesSidebarTitle: 'Source files',},

  // DeleteConfirmationDialog
  deleteConfirmationDialog: {
    areYouSure: 'Are you sure?',
    defaultDescriptionWithName: 'This action cannot be undone. This will permanently delete the {{itemType}} "{{itemName}}".',
    defaultDescriptionWithoutName: 'This action cannot be undone. This will permanently delete this {{itemType}}.',
    itemTypes: {
        'project lead': 'project lead',
      item: 'item',
      thesis: 'solution line',
      'market insight': 'market insight',
      user: 'user',
      solution: 'solution',
      committee: 'committee',
      opportunity: 'opportunity',
      startup: 'startup',
    },
    consequences: {
      startup:
        'Its analysis, one-pager, files, comments and search vector will be deleted. The discovery entries that created it are kept.',
      committee:
        'Its decisions, comments and reports will be deleted, along with its links to opportunities and market insights. The opportunities, solutions and project leads themselves are kept — project leads simply stop referencing this committee.',
    },
  },

  // UploadMarketInsightForm
  uploadMarketInsightForm: {
    title: 'Upload Market Insight',
    uploadButton: 'Upload Report',
    uploadFailed: 'Failed to upload file',
  },

  // ThesisSection
  thesisSection: {
    id: 'ID',
    solutions: 'Solutions',
    solution: 'Solution',
    report: 'Report',
    success: 'Success',
    reportReady: 'Your Report is ready.',
  },

  // SolutionList
  solutionList: {
    noSolutions: 'No solutions available for this solution line.',
  },

  // ThesisTable
  thesisTable: {
    thesis: 'Solution Line',
    status: 'Status',
    solutionsCount: 'Solutions #',
    actions: 'Actions',
    draft: 'draft',
    openMenu: 'Open menu',
    editName: 'Edit Name',
    noThesesFound: 'No solution lines found.',
  },

  // ItemInputDialog
  itemInputDialog: {
    add: 'Add {{itemType}}',
    saveChanges: 'Save Changes',
    adding: 'Adding...',
    saving: 'Saving...',
  },

  // SolutionItem
  solutionItem: {
    edit: 'Edit',
    remove: 'Remove',
    editTooltip: 'Edit this solution',
    removeTooltip: 'Remove this solution',
  },

  // Sidebar
  sidebar: {
    toggleSidebar: 'toggle sidebar',
    terminusButton: "terminus",
    foundersHubButton: "founder's hub",
    gaiaButton: "gaia",
    documentationButton: "documentation",
    organizationButton: "organization",
    superadminButton: "superadmin",
    marketInsights: 'market insights',
    viewAllMarketInsights: 'view all market insights',
    thesis: 'solution lines',
    viewAllThesis: 'view all solution lines',
    settings: 'settings',
    entrepreneur: {
      overview: 'overview',
      opportunities: 'opportunities',
      myOpportunities: 'my ideas',
      sectors: 'sectors',
      applications: 'applications',
      profile: 'profile',
      home: 'home',
    },
    admin: {
      researchCenter: 'research center',
      marketInsights: 'market insights',
      dealflow: 'dealflow',
      discovery: 'discovery',
      opportunities: 'opportunities',
      validation: 'validation',
      projects: 'projects',
      committee: 'committee',
      postCommittee: 'post-committee',
      projectLeads: 'project leads',
      shaping: 'shaping',
      archives: 'archives',
      clients: 'clients',
    },
  },

  // AllThesesView
  allThesesView: {
    title: 'All Solution Lines ({{count}})',
    createNewThesis: 'Create New Solution Line',
    deleteThesis: 'Delete Solution Line',
    thesisName: 'Solution Line Name',
    editThesis: 'Edit Solution Line: {{title}}',
    enterNewThesisName: 'Enter new solution line name',
  },

  // AllOpportunitiesView
  allOpportunitiesView: {
      items: 'items',
      searchPlaceholder: 'Search opportunities...',
    title: 'Opportunities ({{count}})',
    pageTitle: 'Opportunities',
    subtitle: 'Investment opportunities with problem definitions and solution lines',
    createOpportunity: 'Create Opportunity',
    openMenu: 'Open menu',
    deleteTitle: 'Delete Opportunity',
    errorLoading: 'Error loading opportunities: {{message}}',
    stats: {
      total: 'Total',
      totalDesc: 'Total number of opportunities in the system',
      draft: 'Draft',
      draftDesc: 'Opportunities still being defined or refined',
      validated: 'Validated',
      validatedDesc: 'Opportunities reviewed and approved for investment',
      withTheses: 'With Theses',
      withThesesDesc: 'Opportunities with solution lines (theses) defined',
      inCommittee: 'In Committee',
      inCommitteeDesc: 'Opportunities linked to an investment committee session',
      submitted: 'Submitted',
      submittedDesc: 'Submitted by entrepreneurs, pending review',
      hasProject: 'Has Project',
      hasProjectDesc: 'Opportunities that became one or more projects',
      closed: 'Closed',
      closedDesc: 'Opportunities whose committee has closed',
      timeToValidated: 'Time-To-Validation',
      timeToValidatedDesc: 'Average time from creation to validation',
      timeToCommittee: 'Time-To-Committee',
      timeToCommitteeDesc: 'Average time from validation to committee link',
      timeToProject: 'Time-To-Project',
      timeToProjectDesc: 'Average time from committee link to first project',
      totalCycle: 'Cycle Time',
      totalCycleDesc: 'Average end-to-end time from creation to first project',
    
      rejected: 'Rejected',
      approved: 'Approved',
      pending: 'Pending',
      inAssembly: 'In Assembly',
      inLead: 'In Lead',
    },
    types: {
      label: 'Type',
      all: 'Any type',
      marketInsight: 'From Market Insight',
      entrepreneur: 'Entrepreneur',
      internal: 'Internal',
    },
    legend: {
      hoverForDetails: 'Hover over indicators for details',
      urgencyScore: 'Urgency score',
      solutionLines: 'Solution lines',
      dataCompleteness: 'Data completeness (Problem → ICP → Urgency → Solutions)',
    
      lifecycleStage: 'Lifecycle stage',
      title: 'Legend',},
  
    generateFromMarketInsightDescription: 'Pick a processed market insight. We\'ll generate opportunities from its brief.',
    generateFromMarketInsightTitle: 'Generate Opportunities from Market Insight',
    noOpportunities: 'No opportunities found',
    generateFromMarketInsight: 'Generate from Market Insight',},

  // AllMarketInsightsView
  allMarketInsightsView: {
      progress: 'Progress',
      filesCount_other: '{{count}} files',
      filesCount_one: '{{count}} file',
      clear: 'Clear',
    title: 'Market Insights ({{count}})',
    pageTitle: 'Market Research',
    subtitle: 'AI-powered analysis of industry documents for market research',
    createNew: 'Create New Market Insight',
    createTitle: 'Create Market Insight',
    uploadTitle: 'Upload Market Insight',
    openMenu: 'Open menu',
    deleteTitle: 'Delete Market Insight',
    errorLoading: 'Error loading market insights: {{message}}',
    stats: {
      timeToRun: 'Time-To-Run',
      timeToRunDesc: 'Average time from creation to processing start',
      timeToCompletion: 'Time-To-Completion',
      timeToCompletionDesc: 'Average time from start of processing to completed report',
      webResearchPct: '% Web Research',
      webResearchPctDesc: 'Average share of files sourced from web research vs uploaded files',
    },
  
    noInsights: 'No market insights found',},

  // MarketInsightView
  marketInsightSidebar: {
    title: 'Market Insight Details',
    uploadDocuments: 'Upload Documents',
    uploading: 'Uploading',
    uploadedFiles: 'Uploaded Files',
    analysisFilters: 'Analysis Filters',
    startProcessing: 'Start Processing',
    startingProcessing: 'Starting Processing...',
    viewFullPage: 'View Full Page',
    processingStarted: 'Processing started',
    processingStartedDesc: 'Market insight is now being processed',
    processingFailed: 'Failed to start processing',
    uploadFileRequired: 'Upload at least one file to continue',
    completeRequiredFields: 'Complete all required filter fields (marked with *)',
    noSelection: 'No market insight selected',
    opportunities: 'Opportunities',
    opportunitiesGenerated: 'Generated',
  },

  marketInsightProcessing: {
      failed: 'Processing failed',
    title: 'Processing Market Insight',
    description: 'Analyzing documents and generating context summary...',
    statusProcessing: 'Generating opportunities and insights',
    pleaseWait: 'Please wait, this may take a few moments...',
    tryAgain: 'Try Again',
  },

  marketInsightView: {
    success: 'Success',
    notFound: 'Market insight not found',
    loadFailed: 'Failed to load market insight',
    processFiles: 'Process Files',
    overview: 'Overview',
    files: 'Files',
    opportunities: 'Opportunities',
    filters: 'Filters',
    overviewTitle: 'Market Insight Overview',
    filesCount: 'Files',
    opportunitiesCount: 'Opportunities',
    thesesCount: 'Solution Lines',
    fileManagement: 'File Management',
    selectFile: 'Select File',
    upload: 'Upload',
    uploading: 'Uploading...',
    selectedFile: 'Selected file',
    fileUploaded: 'File uploaded successfully',
    uploadFailed: 'Failed to upload file',
    processingStarted: 'Processing started',
    processingFailed: 'Failed to start processing',
    noFiles: 'No files uploaded yet',
    noOpportunities: 'No opportunities generated yet',
    theses: 'Solution Lines',
    noFilters: 'No filters applied',
    notSelected: 'Market Insight or Solution Line not selected.',
    solutionAdded: 'Solution added successfully.',
    solutionUpdated: 'Solution updated successfully.',
    solutionFailed: 'Failed to {{action}} solution. {{message}}',
    add: 'add',
    update: 'update',
    notSelectedForGeneration: 'Market Insight or Solution Line not selected for solution generation.',
    solutionGenerationInitiated: 'Solution generation initiated.',
    generateSolutionFailed: 'Failed to generate solution. {{message}}',
    solutionRemoved: 'Solution removed successfully.',
    removeSolutionFailed: 'Failed to remove solution. {{message}}',
    notSelectedForReportGeneration: 'Market Insight or Solution Line not selected for report generation.',
    reportGenerationInitiated: 'Report generation initiated.',
    generateReportFailed: 'Failed to generate report. {{message}}',
    notSelectedForSolutionsGeneration: 'Market Insight or Solution Line not selected for solutions generation.',
    allSolutionsGenerationInitiated: 'All solutions generation initiated for the solution line.',
    generateSolutionsFailed: 'Failed to generate solutions. {{message}}',
    solution: 'Solution',
    report: 'Report',
    solutionItemType: 'Solution',
    addNewSolution: 'Add New Solution',
    editSolution: 'Edit Solution',
    enterSolutionText: 'Enter solution text',
  },

  // VerifyEmailPage
  verifyEmail: {
    title: 'verify your email',
    sentTo: 'we sent a verification link to {{email}}',
    verified: 'email verified',
    verifiedDesc: 'your email has been verified successfully. redirecting...',
    continue: 'continue to application review',
    expired: 'this verification link has expired. please request a new one.',
    invalid: 'this verification link is invalid. please request a new one.',
    sendFailed: 'failed to send verification email. please try again.',
    step1Title: 'Check your inbox',
    step1Desc: 'We sent a verification link to your email address.',
    step2Title: 'Click the link',
    step2Desc: 'Open the email and click the verification link.',
    step3Title: 'Get verified',
    step3Desc: 'Once verified, your application will proceed to review.',
    resend: 'resend verification email',
    resendIn: 'resend in {{seconds}}s',
    checkSpam: 'didn\'t receive the email? check your spam folder or contact us at',
  },

  // WaitingPage
  waitingPage: {
    title: 'Application Under Review',
    description: 'Thank you for submitting your profile! Our team is reviewing your application.',
    profileSubmitted: 'Profile Submitted',
    profileSubmittedDesc: 'Your application has been successfully submitted for review.',
    underReview: 'Under Review',
    underReviewDesc: 'Our team is currently reviewing your application. This typically takes 1-2 business days.',
    emailNotification: 'Email Notification',
    emailNotificationDesc: 'You\'ll receive an email at <strong>{{email}}</strong> once your application is processed.',
    whatHappensNext: 'What Happens Next?',
    nextSteps: {
      step1: 'Our team analyzes your work background and skills to understand your entrepreneurial potential.',
      step2: 'Within 1-2 business days, you get approval with access details or recommendations to improve your profile.',
      step3: 'Once approved, you\'ll have complete access to terminus.',
    },
    contactUs: 'Questions? Contact us at',
  },

  // ConsentPage
  consentPage: {
    tagline: 'before we begin',
    title: 'terms & consent.',
    subtitle: 'Please review and accept the following agreements to continue.',
    termsLabel: 'I have read and accept the <termsLink>Terms of Service</termsLink> that govern the use of the platform',
    privacyLabel: 'I have read and accept the <privacyLink>Privacy Policy</privacyLink> on how my personal data is handled',
    communicationsLabel: 'I would like to receive ecosystem updates, events, and opportunities relevant to my profile',
    communicationsOptional: '(optional)',
    continueButton: 'accept & continue',
    submitting: 'processing...',
    mandatoryRequired: 'You must accept both the Terms of Service and Privacy Policy to proceed.',
    termsUrl: '/terms',
    privacyUrl: '/privacy',
  },
  legalPage: {
    termsTitle: 'terms of service.',
    privacyTitle: 'privacy policy.',
    loading: 'Loading document...',
    error: 'Failed to load document. Please try again.',
    retry: 'Retry',
    courtesyNotice: 'This is a courtesy translation. The legally binding version is in Spanish.',
    back: 'Back',
  },

  // OnboardingPage
  onboardingPage: {
    title: 'Complete Your Profile',
    stepProgress: 'Step {{current}} of {{total}} - Help us get to know you better',
    linkedInConnected: 'LinkedIn Profile Connected',
    linkedInConnectedDesc: 'Information has been pre-filled from your LinkedIn profile. Please review and update as needed.',
    cvUpdateBanner: 'If your LinkedIn data is incomplete or outdated, you can upload your CV to update your profile.',
    cvUpdateButton: 'upload CV',
    cvUpdateParsing: 'reading your CV...',
    cvUpdateSuccess: 'CV parsed successfully! Your profile has been updated.',

    // Step 0 - LinkedIn URL
    step0: {
      title: 'Autocomplete LinkedIn Profile',
      subtitle: 'Speed up your onboarding by letting us read your professional information from LinkedIn',
      urlLabel: 'LinkedIn Profile URL',
      urlPlaceholder: 'linkedin.com/in/yourname',
      urlHelp: 'Share your LinkedIn profile URL to automatically fill in your professional details',
      buttonIdle: 'Autocomplete My Profile',
      buttonStarting: 'Getting Started...',
      buttonReading: 'Reading Your Profile... {{progress}}%',
      buttonUnderstanding: 'Understanding Your Profile...',
      progressStarting: 'Getting started...',
      progressReading: 'Reading your profile...',
      progressProcessing: 'Processing...',
      errorTitle: 'Something went wrong:',
      linkedinErrorTitle: 'We couldn\'t read your LinkedIn profile.',
      linkedinErrorDescription: 'This can happen if the profile is private or temporarily unavailable. You can try again or upload your CV manually instead.',
      tryAgain: 'Try Again',
      uploadCvInstead: 'upload your CV instead',
      cvUploadTitle: 'upload your CV.',
      cvUploadSubtitle: 'Upload your resume and we\'ll extract your professional information automatically.',
      cvDropzone: 'Drag & drop your CV here, or click to browse',
      cvAcceptedFormats: 'Accepted formats: PDF, DOCX, MD (max 10MB)',
      cvUploading: 'Uploading your CV...',
      cvParsing: 'Reading your CV...',
      cvParseError: 'Failed to parse your CV. Please try again with a different file.',
      backToLinkedin: 'try LinkedIn instead',
      howItWorksTitle: 'How it works:',
      howItWorks1: 'We\'ll read your public profile information',
      howItWorks2: 'Your work experience, education, and skills will be filled in automatically',
      howItWorks3: 'You can review and edit everything before submitting',
      howItWorks4: 'This saves you 5-10 minutes of manual data entry',
    },

    // Step 1 - Personal Info
    step1: {
      title: 'review your info',
      titleWithName: 'looking good, {{name}}',
      subtitle: 'review and edit your basic information',
      firstName: 'First Name',
      firstNamePlaceholder: 'Enter your first name',
      lastName: 'Last Name',
      lastNamePlaceholder: 'Enter your last name',
      location: 'Location',
      locationPlaceholder: 'e.g., San Francisco, CA',
      headline: 'Professional Headline',
      headlinePlaceholder: 'e.g., Founder & CEO at TechCorp',
      industry: 'Industry',
      industryPlaceholder: 'e.g., Technology, Healthcare, Finance',
      summary: 'Professional Summary',
      summaryPlaceholder: 'Brief summary of your professional background...',
    },

    // Step 2 - Work Experience
    step2: {
      title: 'Work Experience',
      subtitle: 'Add your professional experience',
      workExperienceLabel: 'Work Experience',
      sameCompany: '(same company)',
      jobTitle: 'Job Title',
      jobTitlePlaceholder: 'e.g., Senior Software Engineer',
      company: 'Company',
      companyPlaceholder: 'e.g., Google',
      location: 'Location',
      locationPlaceholder: 'e.g., San Francisco, CA',
      startMonth: 'Start Month',
      startYear: 'Start Year',
      endMonth: 'End Month',
      endYear: 'End Year',
      currentlyWork: 'I currently work here',
      description: 'Description',
      descriptionPlaceholder: 'Describe your responsibilities and achievements...',
      addWorkExperience: 'Add Work Experience',
      role: 'role',
      roles: 'roles',
    },

    // Step 3 - Education
    step3: {
      title: 'Education',
      subtitle: 'Add your educational background',
      educationLabel: 'Education',
      school: 'School',
      schoolPlaceholder: 'e.g., Stanford University',
      degree: 'Degree',
      degreePlaceholder: 'e.g., Bachelor of Science',
      fieldOfStudy: 'Field of Study',
      fieldOfStudyPlaceholder: 'e.g., Computer Science',
      startYear: 'Start Year',
      endYear: 'End Year',
      description: 'Description',
      descriptionPlaceholder: 'Activities, societies, honors, etc...',
      addEducation: 'Add Education',
    },

    // Step 4 - Certifications & Skills
    step4: {
      title: 'Certifications & Skills',
      subtitle: 'Add certifications and skills',
      certificationsLabel: 'Certifications',
      certificationLabel: 'Certification',
      certName: 'Name',
      certNamePlaceholder: 'e.g., AWS Solutions Architect',
      certAuthority: 'Issuing Authority',
      certAuthorityPlaceholder: 'e.g., Amazon Web Services',
      certLicense: 'License Number',
      certLicensePlaceholder: 'Optional',
      certUrl: 'URL',
      certUrlPlaceholder: 'e.g., https://...',
      certStartMonth: 'Start Month',
      certStartYear: 'Start Year',
      certEndMonth: 'End Month (if expires)',
      certEndYear: 'End Year',
      addCertification: 'Add Certification',
      skillsLabel: 'Skills',
      skillPlaceholder: 'e.g., JavaScript, Project Management, etc.',
      addSkill: 'Add Skill',
    },

    // Step 5 - Languages & Review
    step5: {
      title: 'Languages & Review',
      subtitle: 'Add languages and review your profile',
      languagesLabel: 'Languages',
      languageName: 'Language (e.g., English, Spanish)',
      languageProficiency: 'Proficiency (e.g., Native, Fluent)',
      addLanguage: 'Add Language',
      reviewTitle: 'Ready to submit',
      reviewDesc: 'Your profile is complete. Submit to continue with your application.',
      noLanguages: 'No languages added',
    },

    // Progress steps
    steps: {
      import: 'Import',
      profile: 'Profile',
      experience: 'Experience',
      complete: 'Complete',
    },

    // Proficiency levels
    proficiency: {
      native: 'Native',
      fluent: 'Fluent',
      professional: 'Professional',
      intermediate: 'Intermediate',
      basic: 'Basic',
    },

    // Misc
    optional: 'optional',
    noExperience: 'No experience added yet',
    noEducation: 'No education added yet',
    present: 'Present',

    // Validation
      validation: {
      firstNameRequired: 'first name is required',
      lastNameRequired: 'last name is required',
      headlineRequired: 'headline is required',
      emptyWorkExperience: 'remove empty work experience entries or fill them in',
      jobTitleRequired: 'job title is required for all work experience entries',
      companyRequired: 'company name is required for all work experience entries',
      schoolRequired: 'school name is required for all education entries',
      languageNameRequired: 'language name is required for all language entries',
      certNameRequired: 'certification name is required for all certification entries',
      locationRequired: 'location is required',
      startDateRequired: 'start date is required',
      endDateRequired: 'end date is required',
      endDateBeforeStart: 'end date cannot be before start date',
      fixErrors: 'please fix the errors above before continuing',
    },

    // Navigation
    back: 'Back',
    next: 'Next',
    continue: 'Continue',
    submitting: 'Submitting...',
    submitForReview: 'Submit for Review',
    platformTagline: 'opportunities for entrepreneurs platform.',

    // Toast messages
    toastUrlSubmitted: 'LinkedIn URL submitted! Reading your profile...',
    toastAutocompleted: 'LinkedIn profile autocompleted successfully!',
    toastInvalidUrl: 'Please enter a valid LinkedIn profile URL (e.g., linkedin.com/in/yourname)',
    toastSubmitFailed: 'Failed to submit LinkedIn URL',
    toastProfileSubmitted: 'Profile submitted for review!',
    toastLoginAgain: 'Please log in again to submit your profile',
    toastProfileFailed: 'Failed to submit profile: {{error}}',
  },

  // LinkedInParsingOverlay
  linkedInParsing: {
    title: 'Reading Your LinkedIn Profile',
    description: 'We\'re reading your LinkedIn profile to understand your professional background. This process typically takes 20-30 seconds.',
    progressComplete: '{{progress}}% complete',
    estimatedTime: 'Estimated time remaining: {{seconds}} seconds',
    statusStarting: 'Getting started...',
    statusConnecting: 'Connecting to LinkedIn...',
    statusReading: 'Reading your profile...',
    statusUnderstanding: 'Understanding your work experience & education...',
    statusReviewing: 'Reviewing your skills & certifications...',
    statusAlmostDone: 'Almost done...',
    pleaseWait: 'Please wait, do not close this window',
    tryAgain: 'Try Again',
  },

  // Entrepreneur FSM States
  entrepreneurStatus: {
    PENDING_LINKEDIN_PARSE: 'Pending LinkedIn',
    PENDING_ONBOARDING: 'Pending Onboarding',
    PENDING_SUMMARY: 'Under Review',
    PENDING_PASSED_PRESCORE: 'Passed Pre-Score',
    PENDING_FAILED_PRESCORE: 'Failed Pre-Score',
    PENDING_WITH_NOTES: 'Review in Progress',
    APPROVED: 'Approved',
    REJECTED: 'Rejected',
    REJECTED_FAILED_PRESCORE: 'Rejected - Failed Pre-Score',
    SUSPENDED: 'Suspended',
    DELETED: 'Deleted',
  },


  // Entrepreneur Dashboard
  entrepreneurDashboard: {
    welcome: 'Welcome back, {{name}}',
    activitySummary: "Here's your activity summary",
    pendingOpportunities: {
      title: 'Opportunities for You',
      emptyTitle: 'No Opportunities Yet',
      emptyState: 'We\'re actively curating opportunities tailored to your unique profile and expertise',
    },
    recommendedOpportunities: 'Recommended Opportunities',
    viewAllOpportunities: 'view all',
    noOpportunities: 'No Opportunities Yet',
    noOpportunitiesDesc: "We're working on finding the best opportunities for you. Check back soon!",
    stats: {
      total: 'Total',
      quickWins: 'Quick Wins',
      strategic: 'Strategic',
      avgMatch: 'Avg Match',
    
      strategicBet: 'Strategic Bet',},
    sectors: {
      title: 'Sectors',
      viewAll: 'View all',
      opportunity: 'opportunity',
      opportunities: 'opportunities',
    },
    applications: {
      title: 'My Applications',
      viewAll: 'View all',
      noApplications: 'No applications yet',
      noApplicationsDesc: 'When you apply to opportunities, they will appear here so you can track their status.',
    },
    card: {
      details: 'Details',
      apply: 'Apply',
      priority: 'Priority',
      match: 'Match',
    },
  },

  // Entrepreneur Opportunity Detail
  entrepreneurOpportunityDetail: {
    opportunityNotFound: 'Opportunity not found',
    applyNow: 'Apply Now',
    applicationFeatureComingSoon: 'Application feature coming soon',
    scores: {
      priority: 'Priority',
      match: 'Match',
      urgency: 'Urgency',
      difficulty: 'Difficulty',
    },
    whyWeRecommend: {
      title: 'Why we recommend this',
      experienceRelevant: 'Your experience in {{sector}} is highly relevant',
      rolesMatch: "Your roles match what we're looking for",
      skillsAlign: 'Your skills align with the project requirements',
    },
    tabs: {
      summary: 'Summary',
      detail: 'Detail',
      requirements: 'What We Look For',
      faq: 'FAQ',
    },
    summary: {
      noDescription: 'No description available.',
      vertical: 'Vertical',
      duration: 'Duration',
      experience: 'Experience',
      yearsPlus: '{{years}}+ years',
    },
    detail: {
      problemContext: 'Problem / Context',
      solutionProposal: 'Solution Proposal',
      scopeDeliverables: 'Scope & Deliverables',
      noDetails: 'No additional details available.',
    },
    requirements: {
      targetRoles: 'Target Roles',
      noRoles: 'No specific roles listed.',
      minimumSeniority: 'Minimum Seniority',
      experienceRequired: '{{years}}+ years of experience required',
      openToAll: 'Open to all experience levels',
      noRequirements: 'No specific requirements listed for this opportunity.',
    },
    faq: {
      selectionProcess: {
        question: 'What is the selection process?',
        answer: 'The selection process consists of several stages: initial application review, technical interview to evaluate your experience and approach, presentation of your solution proposal, and final evaluation by the committee. The entire process typically takes 2-4 weeks.',
      },
      support: {
        question: 'What support will I receive?',
        answer: "Selected entrepreneurs receive comprehensive support including: access to the client's technical team, dedicated mentorship, potential pilot funding, and connections to our network of investors and industry partners.",
      },
      timeCommitment: {
        question: 'What is the time commitment?',
        answer: 'This depends on the project scope, but typically requires full-time dedication during the initial development phase. We work with entrepreneurs to establish clear milestones and timelines that work for both parties.',
      },
      afterApply: {
        question: 'What happens after I apply?',
        answer: "After submitting your application, our team will review your profile and experience. If there's a good fit, we'll reach out to schedule an initial conversation. You'll receive updates on your application status through your dashboard.",
      },
    },
  
    applied: 'Applied',},

  opportunityStatus: {
    applied: 'Applied',
    accepted: 'Accepted',
    rejected: 'Rejected',
    saved: 'Saved',
  },

  // Matched Opportunities
  matchedOpportunities: {
    title: 'matched opportunities',
    description: 'Projects matched to your profile based on your experience and expertise',
    noMatches: 'no matches found',
    noMatchesFiltered: 'Try adjusting your filters to see more opportunities.',
    noMatchesDesc: 'We are continuously analyzing new projects. Check back soon for personalized matches.',
    stats: {
      total: 'Total Matches',
      excellent: 'Excellent (85%+)',
      avgMatch: 'Avg Match',
      avgDomain: 'Avg Domain Fit',
    },
    filters: {
      label: 'Filters',
      status: 'Status',
      allStatus: 'All Status',
      available: 'Available',
      saved: 'Saved',
      applied: 'Applied',
      minScore: 'Min Score',
      allScores: 'All Scores',
      excellent: '85%+ Excellent',
      strong: '70%+ Strong',
      good: '55%+ Good',
      sector: 'Sector',
      allSectors: 'All Sectors',
      clear: 'Clear filters',
    },
    card: {
      matchScore: 'Match',
      domainFit: 'Domain',
      executionFit: 'Exec',
      save: 'Save',
      apply: 'Apply',
      dismiss: 'Dismiss',
    },
  },

  // Matched Opportunity Detail
  matchedOpportunityDetail: {
    notFound: 'Opportunity not found',
    save: 'Save',
    apply: 'Apply',
    dismiss: 'Dismiss this opportunity',
    scores: {
      match: 'Match Score',
      domain: 'Domain Fit',
      execution: 'Execution Fit',
      urgency: 'Urgency',
      difficulty: 'Difficulty',
    },
    whyMatched: {
      title: 'Why This Matches Your Profile',
    },
    riskFlags: {
      title: 'Considerations',
    },
    tabs: {
      summary: 'Summary',
      detail: 'Project Detail',
      requirements: 'Requirements',
    },
    summary: {
      noDescription: 'No description available.',
      vertical: 'Vertical',
      duration: 'Duration',
      experience: 'Experience',
      yearsPlus: '{{years}}+ years',
    },
    detail: {
      problemContext: 'Problem Context',
      solutionProposal: 'Solution Proposal',
      scopeDeliverables: 'Scope & Deliverables',
      noDetails: 'No additional details available.',
    },
    requirements: {
      targetRoles: 'Target Roles',
      noRoles: 'No specific roles defined.',
      minimumSeniority: 'Minimum Seniority',
      experienceRequired: '{{years}}+ years of relevant experience required',
      openToAll: 'Open to all experience levels',
    },
  },

  // Entrepreneur Industries
  entrepreneurIndustries: {
    title: 'Sectors',
    subtitle: 'Explore projects by industry sector',
    projectAvailable: '{{count}} project available',
    projectsAvailable: '{{count}} projects available',
    noProjects: 'No projects available',
    // Keyed by canonical Sector.value (from /api/sectors). One entry per
    // approved category, nothing else — `IndustryDetailPage` defaults to ''
    // when the key is missing rather than rendering legacy strings.
    sectorDescriptions: {
      Energy: 'Energy generation and distribution',
      Aerospace: 'Aerospace and aviation',
      AgriTech: 'Agricultural technology',
      TourismSmartCities: 'Tourism technology and smart cities',
      HealthBiotech: 'Healthcare and biotechnology',
      AdvancedTransport: 'Advanced transport and mobility',
      AdvancedManufacturing: 'Advanced manufacturing and Industry 5.0',
      SustainableResources: 'Sustainable resources and materials',
      SmartInfrastructure: 'Smart infrastructure and construction',
      FinTech: 'Financial technology',
      InsurTech: 'Insurance technology',
    },
  
    noProjectsAvailable: 'No projects available',},

  // Entrepreneur Industry Detail
  entrepreneurIndustryDetail: {
    sectorTitle: 'Sector: {{sector}}',
    sortBy: 'Sort by',
    sortOptions: {
      relevance: 'Relevance for me',
      priority: 'Priority',
      newest: 'Newest first',
    },
    noOpportunities: 'No opportunities in this sector',
    noOpportunitiesDesc: 'Check back later for new opportunities in this sector.',
    moreInfo: '+ info',
    apply: 'Apply',
  },

  // Entrepreneur Applications
  entrepreneurApplications: {
    title: 'My Applications',
    subtitle: 'Track your application status',
    noApplications: 'No applications yet',
    noApplicationsDesc: "When you apply to opportunities, they'll appear here so you can track their progress.",
    browseOpportunities: 'Browse Opportunities',
    appliedOn: 'Applied on {{date}}',
    viewDetails: 'View Details',
    status: {
      pending: 'Pending Review',
      accepted: 'Accepted',
      rejected: 'Not Selected',
    },
  
    stats: {
      total: 'Total Applied',
      recent: 'This Week',
      avgMatch: 'Avg Match',
      avgDomain: 'Avg Domain',
    },},

  // Entrepreneur Profile
  entrepreneurProfile: {
    title: 'My Profile',
    subtitle: 'Your professional profile and account information',
    preScore: 'Pre-score',
    fullTime: 'Full time',
    editProfile: 'Edit profile',
    cancelEdit: 'Cancel',
    saveProfile: 'Save changes',
    saving: 'Saving...',
    aboutMe: 'About me',
    experience: 'Experience',
    education: 'Education',
    skills: 'Skills',
    languages: 'Languages',
    certifications: 'Certifications',
    years: 'years',
    present: 'Present',
    sectorDistribution: 'Sector Distribution',
    roleDistribution: 'Role Distribution',
    keywords: 'Keywords',
    preferences: 'Preferences',
    sectorsOfInterest: 'Sectors of interest',
    availability: 'Availability',
    noSummary: 'No summary added yet',
    noExperience: 'No experience added yet',
    noEducation: 'No education added yet',
    noSkills: 'No skills added yet',
    noLanguages: 'No languages added yet',
    noCertifications: 'No certifications added yet',
  },

  entrepreneur: {
    myOpportunities: {
      title: 'my ideas.',
      subtitle: 'Create and manage your ideas',
      create: 'New Idea',
      empty: "You haven't created any ideas yet.",
      createFirst: 'Create your first idea',
      submit: 'Submit for Review',
    },
    createOpportunity: {
      title: 'new opportunity.',
      subtitle: "Describe the business opportunity you've identified",
      createButton: 'Create Opportunity',
    
      industryPlaceholder: 'e.g. Renewable Energy, SaaS, B2B',
      industry: 'Industry / Vertical',
      sectorPlaceholder: 'Select sector',
      problemPlaceholder: 'Describe the specific problem your solution addresses. What pain does it solve and for whom?',
      problemStatement: 'Problem statement',
      titlePlaceholder: 'e.g. AI-powered predictive maintenance for wind farms',},
    opportunity: {
      submitForReview: 'Submit for Review',
      submitted: 'Submitted',
      overview: 'Overview',
      process: 'Affected Process',
      problem: 'Problem Description',
      committee: 'Committee',
    },
  
    editOpportunity: {
      title: 'edit opportunity',
    },},

  // Market Insight Filters
  marketInsightFilters: {
    // Groupings
    documentMetadata: 'Document Metadata',
    businessThematicAxes: 'Business Thematic Axes',
    geography: 'Geography',
    regulationPolicies: 'Regulation & Policies',
    technologyMaturity: 'Technology / Maturity',

    // Document Metadata filters
    sourceType: 'Source Type',
    sourceTypeOptions: {
      strategicConsultant: 'Strategic Consultant',
      fundInvestor: 'Fund/Investor',
      specializedMedia: 'Specialized Media',
      publicOrganization: 'Public Organization',
      thinkTankNgo: 'Think Tank / NGO',
      operatingCompany: 'Operating Company',
      academic: 'Academic',
    },
    publicationDate: 'Publication Date',
    publicationDatePresets: {
      ytd: 'YTD',
      last90Days: 'Last 90 days',
      last6Months: 'Last 6 months',
      lastYear: 'Last year',
      last2Years: 'Last 2 years',
    },
    analysisTemporalCoverage: 'Analysis Temporal Coverage',
    analysisTemporalCoverageOptions: {
      historical: 'Historical',
      range2025_2030: '2025-2030',
      range2031_2040: '2031-2040',
      beyond2040: '>2040',
    },

    // Business Thematic Axes
    verticalSubsector: 'Vertical / Subsector',
    verticalSubsectorPlaceholder: 'Enter vertical or subsector',
    // Vertical labels come from /api/sectors (display_name), not the locale.

    // Geography
    region: 'Region',
    regionOptions: {
      global: 'Global',
      eu27: 'EU-27',
      northAmerica: 'North America',
      latam: 'LatAm',
      emea: 'EMEA',
      apac: 'APAC',
      spain: 'Spain',
    },

    // Regulation & Policies
    includeRegulatoryFramework: 'Include Regulatory Framework',
    includeRegulatoryFrameworkOptions: {
      yes: 'Yes (mentions specific legal framework)',
      no: 'No',
    },
    regulationType: 'Type of Regulation',
    regulationTypeOptions: {
      euDirective: 'EU Directive',
      euRegulation: 'EU Regulation',
      nationalLaw: 'National Law',
      technicalStandard: 'Technical Standard',
      taxIncentive: 'Tax Incentive',
      subsidyPublicFund: 'Subsidy/Public Fund',
    },

    // Technology / Maturity
    protagonistTechnology: 'Protagonist Technology',
    protagonistTechnologyPlaceholder: 'Enter protagonist technology (e.g., AI, blockchain)',

    // Common filter labels
    selectPlaceholder: 'Select...',
    fromDate: 'From',
    toDate: 'To',
    clearFilters: 'Clear All Filters',
    applyFilters: 'Apply Filters',
    resetFilters: 'Reset Filters',
  },

  // Opportunities
  opportunities: {
      generationFailed: 'Generation failed',
    regeneratingOverlay: {
      title: 'Regenerating Opportunity',
      description: 'AI is refreshing the opportunity context...',
    },
    deleteFailed: 'Could not delete the opportunity',
    deleteSolutionFailed: 'Could not delete the solution',
    fromMarketInsight: 'Research context',
    fromStartup: 'Source startup',
    startupContextDescription: 'This opportunity was generated from this startup. Open it to review its profile.',
    audit: {
      created: 'created {{date}}',
      validated: 'validated {{date}}',
      validatedBy: 'validated by {{name}}{{date}}',
      decided: 'decided {{date}}',
      decidedBy: 'decided by {{name}}{{date}}',
    },
    noOpportunitiesFound: 'No Opportunities Found',
    statusSubmitted: 'Submitted',
    processFilesPrompt: 'Process your uploaded files to generate market opportunities.',
    marketOpportunities: 'Market Opportunities ({{count}})',
    b2bAnalysis: 'B2B opportunities with comprehensive analysis',
    view: 'View',
    edit: 'Edit',
    delete: 'Delete',
    editOpportunity: 'Edit Opportunity',
    deleteOpportunity: 'Delete Opportunity',
    validate: 'Validate',
    devalidate: 'Remove from pending approval',
    markAsPendingValidation: 'Mark as Pending Validation',
    solutionLines: 'solution line(s)',
    solutions: 'solution(s)',

    // Dialog
    createOpportunity: 'Create New Opportunity',
    updateOpportunity: 'Update Opportunity',
    newOpportunity: 'New Opportunity',
    newOpportunityDescription: 'Create a new business opportunity',
    forMarketInsight: 'For: {{name}}',
    lockedFromMarketInsight: 'Locked from Market Insight filters',
    researchContext: 'Research Context',
    researchContextDescription: 'Link a market insight to use as context for AI generation',
    linkMarketInsight: 'Link Market Insight',
    linkMarketInsightDescription: 'Select a processed market insight to use as research context for AI generation.',
    noProcessedMarketInsights: 'No processed market insights available. Run a market insight first.',
    noMatchingMarketInsights: 'No market insights match your search.',

    // Opportunity Model
    opportunity: {
      sectionName: '📋 Opportunity',
      title: 'Opportunity Title',
      titlePlaceholder: 'Brief opportunity title (2-5 words)...',
      slug: 'Slug',
      slugPlaceholder: 'OP-SECTOR-VERTICAL-01',
      slugHelper: 'Auto-generated format: OP-SECTOR-VERTICAL-NN',
      sector: 'Sector',
      sectorPlaceholder: 'e.g., ENERGY, TECH, FINANCE',
      vertical: 'Vertical / Industry',
      verticalPlaceholder: 'e.g., GRID, FINTECH, AGRITECH',
      affectedProcess: 'Affected Business Process',
      affectedProcessPlaceholder: 'Which business process is impacted...',
    },

    // ICP Model
    icp: {
      sectionName: '🎯 ICP',
      segment: 'Target Customer Segment',
      segmentPlaceholder: 'Describe the target customer segment...',
      size: 'Total Addressable Market (TAM)',
      sizePlaceholder: 'e.g., $500M TAM, 10,000 companies in LATAM',
      keyRoles: 'Key Decision Maker Roles',
      keyRolesPlaceholder: 'CTO, CFO, Operations Director',
      keyRolesHelper: 'Comma-separated roles',
    },

    // Problem Model
    problem: {
      sectionName: '⚠️ Problem',
      description: 'Problem Statement',
      descriptionPlaceholder: 'Describe the core problem this opportunity addresses...',
      kpiMetric: 'Current KPI Being Measured',
      kpiMetricPlaceholder: 'e.g., Response Time, Cost per Transaction, Error Rate',
      kpiValue: 'Current KPI Value (Baseline)',
      kpiValuePlaceholder: 'e.g., 120',
      kpiUnit: 'KPI Unit of Measurement',
      kpiUnitPlaceholder: 'e.g., seconds, USD, percentage',
      kpiPeriod: 'KPI Measurement Period',
      kpiPeriodPlaceholder: 'e.g., monthly average, Q1 2024',
      painType: 'Pain Point Category',
      painTypePlaceholder: 'cost | time | risk | quality',
      painTypeHelper: 'Primary type of pain this addresses',
      painEstimatedImpact: 'Estimated Pain Impact',
      painEstimatedImpactPlaceholder: 'Quantify the impact (e.g., $2M annual loss, 40% time waste)...',
      painSource: 'Pain Source / Citation',
      painSourcePlaceholder: 'Source reference or citation for this pain point',
    },

    // MarketWindow Model
    marketWindow: {
      sectionName: '⏰ MarketWindow',
      urgencyScore: 'Urgency Score (1-5)',
      urgencyScorePlaceholder: '1-5',
      urgencyScoreHelper: '1 = low urgency, 5 = critical/time-sensitive',
      regulatoryOrContract: 'Regulatory/Contract Drivers',
      regulatoryOrContractPlaceholder: 'External regulatory requirements or contractual obligations driving this...',
      marketTriggers: 'Market Triggers & Events',
      marketTriggersPlaceholder: 'New regulation coming Q2 2024\nMajor competitor launched similar product\nGovernment subsidy announced',
      marketTriggersHelper: 'One trigger per line',
    },

    // Constraints Model
    constraints: {
      sectionName: '🔒 Constraints',
      data: 'Data Availability & Requirements',
      dataPlaceholder: 'What data is needed? Is it available? Quality concerns?',
      it: 'IT Systems Integration',
      itPlaceholder: 'Required integrations, legacy systems, APIs needed...',
      compliance: 'Compliance & Regulatory',
      compliancePlaceholder: 'GDPR, HIPAA, SOC2, industry-specific regulations...',
      dataResidency: 'Data Residency Requirements',
      dataResidencyPlaceholder: 'e.g., EU-only, US-only, LATAM-only',
      onpremCloud: 'Deployment Model',
      onpremCloudPlaceholder: 'onprem | cloud | hybrid',
      onpremCloudHelper: 'On-premises, cloud, or hybrid deployment',
    },

    // SuccessObjective Model
    successObjective: {
      sectionName: '🎯 SuccessObjective',
      kpiAfter: 'Target KPI After Implementation',
      kpiAfterPlaceholder: 'e.g., 30 seconds (from 120 seconds baseline)',
      expectedImprovement: 'Expected Improvement',
      expectedImprovementPlaceholder: 'e.g., 75% reduction, 3x increase, $1M annual savings',
      maxTtvDays: 'Max Time-to-Value (days)',
      maxTtvDaysPlaceholder: 'e.g., 90',
      maxTtvDaysHelper: 'Maximum acceptable time to see value',
      maxPaybackMonths: 'Max Payback Period (months)',
      maxPaybackMonthsPlaceholder: 'e.g., 12',
      maxPaybackMonthsHelper: 'Maximum acceptable time to recover investment',
    },

    // BenchmarkGap Model
    benchmarkGap: {
      sectionName: '🌍 BenchmarkGap',
      notableCases: 'Notable Reference Cases',
      notableCasesPlaceholder: 'Notable case studies from China, EU, USA showing proven solutions...',
      gapComparison: 'Gap vs Advanced Markets',
      gapComparisonPlaceholder: 'How does current state compare to China/EU/USA leaders? Cost, speed, tech advantages...',
      transferabilityRisks: 'Transferability Risks',
      transferabilityRisksPlaceholder: 'Risks when adapting solutions from other markets (cultural, regulatory, infrastructure)...',
    },

    // Display fields (for OpportunityTableItem and OpportunityBody)
    display: {
      basicInfo: 'Basic Information',
      description: 'Description',
      aiContext: 'AI-derived context',
      affectedProcess: 'Affected Process',
      idealCustomerProfile: 'Ideal Customer Profile',
      segment: 'Segment',
      marketSize: 'Market Size',
      keyRoles: 'Key Roles',
      problemDefinition: 'Problem Definition',
      currentKPI: 'Current KPI',
      painType: 'Pain Type',
      marketWindow: 'Market Window',
      urgencyScore: 'Urgency Score',
      regulatoryContract: 'Regulatory/Contract',
      marketTriggers: 'Market Triggers',
      constraints: 'Constraints',
      data: 'Data',
      itIntegration: 'IT Integration',
      compliance: 'Compliance',
      dataResidency: 'Data Residency',
      successObjectives: 'Success Objectives',
      targetKPI: 'Target KPI',
      expectedImprovement: 'Expected Improvement',
      maxTTV: 'Max TTV',
      maxPayback: 'Max Payback',
      benchmarkGapAnalysis: 'Benchmark & Gap Analysis',
      notableCases: 'Notable Cases',
      gapComparison: 'Gap Comparison',
      transferabilityRisks: 'Transferability Risks',
      chinaSignals: 'Market signals',
      rootCauses: 'Root causes',
      currentState: 'Current state',
    },
  
    saveChanges: 'Save Changes',
    creating: {
      title: 'Creating Opportunity',
      description: 'AI is enriching your input with full opportunity context...',
    },
    markAsDraftDescription: 'This opportunity will return to Draft. You can re-submit it for validation later.',
    markAsDraftTitle: 'Move back to Draft?',
    cannotSubmitWithoutSolutions: 'Add at least one solution before submitting for validation.',
    markAsDraft: 'Mark as Draft',
    submitForValidation: 'Submit for validation',
    pick_seed_description: 'The chosen startup\'s onepager becomes context for the AI.',
    pick_seed_title: 'Pick a seed startup',
    no_seed_startup: 'No seed startup yet.',
    add_seed_startup: 'Pick seed startup',
    seed_startup_section_description: 'One startup whose onepager guides the AI — links this opportunity back to that startup.',
    seed_startup_section: 'Seed Startup (AI Context)',
    linkedTo: 'Linked to {{name}}',
    solutionsLabel: 'solution',
    regenerate: 'Regenerate',
    regenerating: 'Regenerating...',
    generatingStatus: 'Running opportunity analysis',
    generatingDescription: 'Analyzing the brief and extracting market opportunities...',
    generating: 'Generating Opportunities',},
  solutionLines: {
    itemType: 'solution line',
    generate: 'Generate with AI',
    add: 'Add line',
    empty:
      'No solution lines yet. Generate them with AI, or add one yourself if you already know the strategy.',
    generating: 'Generating solution lines',
    generatingDescription:
      'Mapping the strategies that could solve this opportunity, one per angle.',
    analyzing: 'Exploring angles...',
    generateFailed: 'Could not generate solution lines',
    createFailed: 'Could not create the solution line',
    updateFailed: 'Could not update the solution line',
    deleteFailed: 'Could not delete the solution line',
    newTitle: 'New solution line',
    newDescription:
      'Name the strategy. Leave the angle and description empty and the agent writes them for you; fill either in and the line is stored exactly as typed.',
    expanding: 'Expanding the solution line',
    expandingDescription:
      'Working out the angle and the description for "{{title}}" from this opportunity.',
    editTitle: 'Edit solution line',
    editDescription: 'Change how this strategy is named and described.',
    regenerate: 'Regenerate line',
    regenerating: 'Regenerating the solution line',
    regeneratingDescription:
      'Rewriting this line and re-deriving the typology of the solutions under it.',
    regenerateFailed: 'Could not regenerate the solution line',
    stats: {
      lines_one: '{{count}} solution line',
      lines_other: '{{count}} solution lines',
    },
    fields: {
      title: 'Title',
      titlePlaceholder: 'e.g. Predictive Berth Scheduling',
      angle: 'Angle',
      anglePlaceholder: 'e.g. PROCESS, TECHNOLOGY, DATA...',
      description: 'Description',
      descriptionPlaceholder: 'What is done, and why it solves the problem from that angle.',
    },
  },
  solutions: {
    title: 'Solutions ({{count}})',
    addSolution: 'Add Solution',
    generatingDraft: 'Generating Solution Draft',
    generatingDraftDescription: 'AI is analyzing the opportunity and generating a solution...',
    regenerate: 'Regenerate',
    regenerating: 'Regenerating Solution',
    regeneratingDescription: 'Refreshing the summary, data and matched startups while keeping the title...',
    startupsCountTooltip: 'Matched startups',
    startups: 'Startups',
    partnerArchetype: 'Partner archetype',
    partnerArchetypePlaceholder: 'e.g. drone hardware OEM',
    partnerArchetypeHelper: 'The type of startup/partner that delivers this',
    solutionType: 'Solution type',
    solutionTypePlaceholder: 'Pick one',
    solutionTypeHelper:
      'How far this solution sits from what the problem literally asks for.',
    solutionTypes: {
      direct: 'Direct solution',
      adjacent_solution: 'Adjacent solution',
      adjacent_technology: 'Adjacent technology',
    },
    uncategorized: 'No solution line',
    noSolutionsInLine: 'No solutions on this line yet.',
    stats: {
      validated: '{{count}} validated',
      approved: '{{count}} approved',
      rejected: '{{count}} rejected',
      reports: '{{count}} reports',
      avgScore: 'avg {{score}}/100',
    },
    badges: {
      report: 'Report',
    },
    editSolution: 'Edit Solution',
    validationItems: 'Validation items for this solution line',
    content: 'Content',
    contentPlaceholder: 'Enter solution content...',
    editDescription: 'Update the solution content',
    createDescription: 'Add a new solution to validate this solution line',
    create: 'Create',
    update: 'Update',
    dialog: {
      sections: {
        basicInfo: 'Basic Information',
        coveragePartner: 'Partner',
        solutionDetails: 'Solution Details',
        citationsScoring: 'Citations & Scoring',
        scoreBreakdown: 'Score Breakdown',
      },
      solutionTitle: 'Solution Title',
      solutionTitlePlaceholder: 'e.g., Grid Operational Twin',
      scope: 'Scope',
      scopePlaceholder: 'What the solution does and how it addresses the affected process...',
      scopeHelper: 'Write fluently — sources go in the Evidence Citations list below, not inline.',
      technology: 'Technology',
      technologyPlaceholder: 'Technical approach, patterns, architecture...',
      technologyHelper: 'Write fluently — sources go in the Evidence Citations list below, not inline.',
      operation: 'Operation',
      operationPlaceholder: 'How it operates, deployment model, integration approach...',
      operationHelper: 'Write fluently — sources go in the Evidence Citations list below, not inline.',
      businessModel: 'Business Model',
      businessModelPlaceholder: 'Pricing, licensing, engagement model...',
      businessModelHelper: 'Write fluently — sources go in the Evidence Citations list below, not inline.',
      evidenceCitations: 'Evidence Citations',
      evidenceCitationsPlaceholder: 'Source Title - https://example.com (scope, technology)\nAnother Source - https://example.com (operation)',
      evidenceCitationsHelper: 'One citation per line: title - url (fields referenced)',
      totalScore: 'Total Score',
      totalScorePlaceholder: '87',
      totalScoreHelper: 'Sum of all subscores (max 100)',
      lineFitScore: 'Line Fit Score',
      lineFitScorePlaceholder: '25',
      lineFitScoreHelper: '0-30 points',
      startupFitScore: 'Startup Fit Score',
      startupFitScorePlaceholder: '25',
      startupFitScoreHelper: '0-30 points',
      dataFeasibilityScore: 'Data Feasibility Score',
      dataFeasibilityScorePlaceholder: '13',
      dataFeasibilityScoreHelper: '0-15 points',
      ttvPaybackScore: 'TTV/Payback Score',
      ttvPaybackScorePlaceholder: '8',
      ttvPaybackScoreHelper: '0-10 points',
      transferabilityScore: 'Transferability Score',
      transferabilityScorePlaceholder: '4',
      transferabilityScoreHelper: '0-5 points',
      businessModelIcpScore: 'Business Model/ICP Score',
      businessModelIcpScorePlaceholder: '7',
      businessModelIcpScoreHelper: '0-10 points',
    
      technologyHelperOptional: 'Optional: AI will generate this if left empty.',
      summaryHelper: 'What is this solution? The AI will use this to fill in the rest.',
      solutionSummaryPlaceholder: '1–3 sentence executive summary',
      solutionSummary: 'Summary',},
  
    upgrade: 'Upgrade',
    upgrading: 'Upgrading...',
    upgradeFailed: 'Failed to upgrade solution',
    upgraded: 'Solution upgraded to the new format',
    newSolutionDescription: 'AI will fill in the rest from your input',
    newSolution: 'New Solution',
    creating: {
      title: 'Creating Solution',
      description: 'AI is generating the full solution from your input...',
    },
    no_startup_matches: 'No startups match your query.',
    search_startups_placeholder: 'Search startups by name, sector, technology...',
    generateBulk: 'Generate (5)',
    pick_seed_description: 'The chosen startup\'s onepager becomes context for the AI.',
    pick_seed_title: 'Pick a seed startup',
    no_seed_startup: 'No seed startup yet.',
    add_seed_startup: 'Pick seed startup',
    seed_startup_section_description: 'One startup whose onepager guides the AI — same role a market insight plays for an opportunity. The seed lands at position 0 of the matched-startup list with normal scoring; the lowest-scored entry is dropped to keep the list at 20.',
    seed_startup_section: 'Seed Startup (AI Context)',},

  committee: {
      unnamed: 'Committee {{id}}',
      errorLoading: 'Error loading committees: {{message}}',
    all_committees: 'All Committees',
    committees: 'Committees',
    pending_pre_committees: 'Pending Pre-Committee',
    pre_done_committees: 'Pre-Committee Done',
    post_done_committees: 'Post-Committee Done',
    title: 'Committees',
    subtitle: 'Review and manage committee sessions',
    list_subtitle: 'Review and manage investment committees',
    view_subtitle: 'Review and prioritize opportunities ready for committee',
    pre_committee_package: 'Pre-Committee Package',
    committee_session: 'Committee Session',
    opportunities_label: 'Opportunities',
    solution_lines_label: 'Solution Lines',
    validated_opportunities: 'Validated Opportunities',
    validated_opportunities_subtitle: 'Opportunities from the market insight document',
    items_count: '{{count}} items',
    add_opportunity: 'Add',
    no_committees: 'No committees found',
    no_committees_filter: 'No committees found with this status',
    error: 'Failed to load committees',
    error_loading: 'Error loading committees',
    pre_date: 'Pre-Committee',
    post_date: 'Post-Committee',
    pre_date_label: 'Pre',
    post_date_label: 'Post',
    back_to_list: 'Back to Committees',
    overview: 'Overview',
    total_committees: '{{count}} total committees',
    status: {
      all: 'All Status',
      pending_pre: 'Pending Pre-Committee',
      pre_done: 'Pre-Committee Done',
      post_done: 'In Shaping',
      closed: 'Closed',
    },
    status_label: {
      pending: 'Pending',
      pre_done: 'Pre Done',
      completed: 'Completed',
    },
    status_filter: 'Status Filter',
    search_placeholder: 'Search committees...',
    generatingReport: 'Generating Pre-Committee Report',
    generatingDescription: 'Please wait while we compile your report...',
    analyzingContent: 'Analyzing opportunities, theses, and solutions...',
    reportDownloaded: 'Report successfully downloaded!',
    reportError: 'Please try again or contact support if the issue persists.',
    pre_committee_report: 'Pre-Committee Report',
    post_committee_report: 'Post-Committee Report',
    report_status: {
      ready: 'Ready to generate',
      generated: 'Report generated',
      approve_first: 'Approve solutions to generate report',
      no_opportunities: 'No opportunities to export',
    },
    opportunities_count: '{{count}} opportunities',
    theses_count: '{{count}} solution lines',
    solutions_count: '{{count}} solutions',
    generating: 'Generating...',
    download_report: 'Download Report',
    generate_report: 'Generate Report',
    download_current_document: 'Download current document',
    regenerate_document: 'Regenerate document',
    package_content: 'Package Content',
    package_content_description: 'Opportunities, solution lines and solutions for review',
    market_insight_opportunities: 'Market Insight Opportunities',
    opportunities_heading: 'Opportunities',
    no_opportunities: 'No opportunities',
    no_opportunities_description: 'Add opportunities to include them in this committee review.',
    add_opportunity_title: 'Add Opportunity',
    add_opportunity_dialog_description: 'Opportunities pending validation, not yet linked to any committee.',
    opportunities_from_insight: 'Opportunities from Market Insight',
    notes_saved: 'Notes saved',
    notes_saved_description: 'Committee notes have been saved successfully.',
    notes_error: 'Error saving notes',
    post_report_generated: 'Report Downloaded',
    post_report_downloaded: 'Your post-committee report has been generated and downloaded.',
    post_report_error: 'Error',
    post_report_error_description: 'Failed to generate post-committee report. Please try again.',
    decision_saved: 'Decision saved',
    decision_error: 'Error saving decision',
    decision: {
      approved: 'Approved',
      rejected: 'Rejected',
      pending: 'Pending',
      approved_solutions: 'Approved sol.',
      rejected_solutions: 'Rejected sol.',
      approved_opportunities: 'Approved opp.',
      rejected_opportunities: 'Rejected opp.',
      notesPlaceholder: 'Notes for this solution (auto-saved)',
      opportunityNotesPlaceholder: 'Notes for this opportunity (auto-saved)',
      addNote: 'Add note',
      cascadedApproved: 'auto-approved',
      cascadedRejected: 'auto-rejected',
      cascadedHint:
        'Auto-approved with the parent opportunity. Click approve to confirm.',
      cascadedRejectedHint:
        'Auto-rejected with the parent opportunity. Click reject to confirm.',
      confirmCascadedHint: 'Confirm this auto-approval as your decision',
      confirmCascadedRejectHint: 'Confirm this auto-rejection as your decision',
    },
    decisions_description: 'Vote on opportunities and solutions',
    opportunity_notes_placeholder: 'Add committee notes for this opportunity...',
    solution_notes_placeholder: 'Add committee notes for this solution...',
    decided_count: '{{decided}}/{{total}} decided',
    count_approved: '{{count}} approved',
    count_rejected: '{{count}} rejected',
    generating_post_committee_report: 'Generating Post-Committee Report',
    minutes_button: 'Minutes & transcription',
    minutes_panel_title: 'Minutes & transcription',
    minutes_panel_description:
      'Upload the meeting transcription. The minutes are generated automatically from it and can be edited before closing the committee.',
    minutes_generating: 'Generating minutes from the transcription…',
    minutes_empty_closed: 'No minutes were recorded for this committee.',
    notes_title: 'Session Minutes',
    notes_description:
      'Auto-generated from the transcription. Review and edit before closing.',
    notes_placeholder: 'Upload a transcription to generate the minutes, or write them here…',
    save_minutes: 'Save Minutes',
    transcript_title: 'Meeting Transcription',
    transcript_description:
      'Upload the meeting transcription. The minutes are generated automatically from it.',
    transcript_uploaded: 'Transcription uploaded',
    transcript_upload: 'Upload',
    transcript_replace: 'Replace',
    transcript_lang_es: 'Spanish',
    transcript_lang_en: 'English',
    transcript_lang_hint:
      'Dominant language of the meeting — the minutes are written in it. Mixed-in sentences in the other language are handled.',
    validated_elements: 'Solution Decisions',
    solution_decisions_description: 'Vote on each solution to determine next steps',
    no_validated_opportunities: 'No validated opportunities',
    no_validated_theses: 'No validated solution lines',
    no_validated_solutions: 'No validated solutions',
    validated_theses: 'Solution Lines',
    validated_solutions: 'Solutions',
    add: 'Add',
    summary: 'Summary',
    market_insights: 'Market Insights',
    no_market_insights: 'No market insights',
    no_market_insights_description: 'Add market insights to include them in this committee review.',
    add_market_insight: 'Add Market Insight',
    add_market_insight_description: 'Select a market insight to add to this committee.',
    search_market_insights: 'Search market insights...',
    no_available_market_insights: 'No market insights available to add.',
    no_matching_market_insights: 'No market insights match your search.',
    error_loading_market_insights: 'Error loading market insights',
    add_n_items: 'Add ({{count}})',
    already_added: 'Already added',
    in_n_committees: 'In {{count}} committee(s)',
    validated_label: 'validated',
    remove_market_insight: 'Remove Market Insight',
    remove_market_insight_description: 'Are you sure you want to remove this market insight from the committee? It will not be deleted and can be added again later.',
    search_opportunities: 'Search opportunities...',
    no_available_opportunities: 'No opportunities pending validation are available.',
    no_matching_opportunities: 'No opportunities match your search.',
    workflow: {
      title: 'Committee Workflow',
      pending_pre: 'Pending Pre-Committee',
      pending_pre_desc: 'Waiting for pre-committee report',
      pre_done: 'Pre-Committee Done',
      pre_done_desc: 'Pre-report ready, waiting for post-committee',
      post_done: 'In shaping',
      post_done_desc: 'Decisions finalized; approved opportunities are being assembled into project leads',
      closed: 'Closed',
      closed_desc: 'Fully closed; every approved opportunity assigned to a project lead',
      current: '← Current',
      not_started: 'Committee workflow not started yet',
      not_started_label: 'Not Started',
    
      failed: 'Report generation failed',},
    report: {
        error_badge: '{{label}} Error',
      pre_title: 'Pre-Committee Report',
      post_title: 'Post-Committee Report',
      pre_desc: 'Pre-committee report summarizes opportunities and theses before the meeting',
      post_desc: 'Post-committee report documents decisions and next steps after the meeting',
      error: '{{label}}-Committee Report Error',
      error_desc: 'Report generation failed. Click to view details and retry.',
      ready: '{{label}}-Committee Report Ready',
    },
    decisions_summary: {
      title: 'Committee Decisions',
      total: '{{count}} total',
      approved_desc: 'opportunities moving forward',
      rejected_desc: 'opportunities declined',
      pending_desc: 'awaiting decision',
    },
    stats: {
      total: 'Total',
      total_desc: 'Total committees created in the system',
      pending_pre: 'Pending Pre',
      pending_pre_desc: 'Committees waiting for pre-committee meeting',
      pre_done: 'Pre Done',
      pre_done_desc: 'Pre-committee completed, waiting for post-committee',
      completed: 'Completed',
      completed_desc: 'Full committee workflow completed with final decisions',
      in_shaping: 'In Shaping',
      in_shaping_desc: 'Decisions finalized; approved opportunities are being assembled into project leads.',
      closed: 'Closed',
      closed_desc: 'Fully closed: every approved opportunity has been assigned to a project lead.',
      with_decisions: 'With Decisions',
      with_decisions_desc: 'Committees that have recorded opportunity decisions',
    },
    legend: {
      workflow_stage: 'Workflow Stage',
      workflow_progress: 'Workflow progress',
      report_ready: 'Report ready',
      decisions: 'Decisions',
      clear_filter: 'Clear filter',
      items: 'items',
      opportunities: 'opportunities',
      from_insight: 'from market insight',
      pre_meeting_date: 'Pre-committee meeting date',
      post_meeting_date: 'Post-committee meeting date',
      view_details: 'View Details',
    },
    statusLabel: 'Status',
    report_button: {
      pre: 'Pre-committee report',
      post: 'Post-committee report',
      download_pre: 'Download Pre-Report',
      download_post: 'Download Post-Report',
      regenerate: 'Regenerate report',
    },
    solutionsLabel: 'Solutions',
    solutionCount_one: '{{count}} solution',
    solutionCount_other: '{{count}} solutions',
    solutionCount: '{{count}} solutions',
    viewProjectLead: 'Project lead',
    solutionsHeading: 'Solutions',
    opportunitiesSubtitle: 'Vote on opportunities and their solutions. Notes auto-save.',
    noOpportunitiesYet: 'No opportunities in this committee yet.',
    noSolutionsYet: 'No solutions yet. Add one or run the generator.',
    actions: {
      addSolution: 'Add solution',
      generateSolutions: 'Generate solutions…',
      editOpportunity: 'Edit opportunity',
      editSolution: 'edit solution',
      removeFromCommittee: 'Remove from committee',
    },
    panels: {
      editOpportunity: 'edit opportunity',
      addSolution: 'new solution',
    },
    close: {
      button: 'Close committee',
      alreadyClosed: 'committee closed',
      inPostCommittee: 'in post-committee',
      title: 'Close committee',
      description:
        'Closing the committee will trigger Project Lead generation for each approved opportunity. This action is irreversible.',
      confirmButton: 'Close committee',
      checkPreReport: 'Pre-committee report generated',
      checkPostReport: 'Post-committee report generated',
      checkTranscript: 'Transcription uploaded & minutes generated',
      approvedOpportunitiesLabel: 'Approved opportunities',
      noApprovedYet:
        'No opportunity has been approved yet — closing will not produce any artifacts.',
      warning:
        'This will close the committee and trigger Project Lead generation for each of the approved opportunities. This is irreversible.',
      processing: 'Generating artifacts…',
    
      checkAllNotesMissing: '{{count}} decision(s) missing notes',
      checkAllNotes: 'Every decision has notes',
      checkAllDecidedMissing: '{{count}} opportunity(ies) still undecided',
      checkAllDecided: 'Every opportunity has a decision',},
  
    notify: {
      partial: 'Notified {{sent}} of {{total}} experts',
      success: 'Invitation sent to {{count}} experts',
      error: 'Could not send notifications',
    },
    preReport: {
      overlay: {
        title: 'Generating Pre-Committee Report',
        queued: 'Generating report content...',
        rendering: 'Rendering PDF...',
        downloading: 'Downloading file...',
      },
    },
    postReport: {
      overlay: {
        title: 'Generating Post-Committee Report',
        queued: 'Generating report content...',
        rendering: 'Rendering PDF...',
        downloading: 'Downloading file...',
      },
    },
    linkedOpportunities: 'Opportunities already linked',
    untitled_solution: 'Untitled solution',
    sectors_picker_title: 'Select committee sectors',
    sectors_placeholder: 'Select sectors',
    sectors_label: 'Sectors',
    name_placeholder: 'e.g., Q1 2026 Energy Review',
    name_label: 'Name',
    create_description: 'Create a new committee to review and prioritize opportunities.',
    editSolutionLines: 'Click to add or remove solution lines',
    schedule: {
      date_label: 'Meeting date & time',
      location_label: 'Location',
      location_placeholder: 'Select a location',
      location_none: 'No location',
      saved_no_invites: 'Schedule saved. No new invitations to send.',
      button: 'Schedule',
      title: 'Schedule meeting',
      description: 'Set when and where this committee meets. Experts are notified when you send the invitation.',
      send_disclaimer: 'Sending will email the invitation to participants.',
      send: 'Send',
    },
    no_sectors: 'No sectors',
    no_staff: 'No staff assigned',
    no_experts: 'No experts assigned',
    participants: 'Participants',
    noSolutionsClosed: 'No solutions were recorded.',
    opportunities: 'Opportunities',
    create: 'Create Committee',
    staff: 'Staff',
    experts: 'Experts',
    no_matching_participants: 'No participants match your search.',
    no_available_participants: 'No participants available to add.',
    search_participants: 'Search participants...',
    add_participant_description: 'Select experts and staff to add to this committee.',
    add_participant: 'Add participant',
    add_opportunities_partial_failed: '{{count}} failed: {{message}}',
    add_opportunity_failed: 'Failed to add opportunity',
    add_opportunities_success: 'Added {{count}} opportunity(ies)',},

  project: {
    tabs: {
      solutions: 'Solutions',
      strategy: 'Strategy',
      clients: 'Clients',
      assets: 'Assets',
    },
    title: 'Projects',
    subtitle: 'Manage validated opportunities as projects',
    new_project: 'New Project',
    edit_project: 'Edit Project',
    no_projects: 'No projects found',
    back_to_list: 'Back to Projects',
    not_found: 'Project not found',
    search_placeholder: 'Search projects...',
    delete_confirm: 'Are you sure you want to delete this project?',
    deleted: 'Project deleted',
    deleted_description: 'The project has been deleted successfully.',
    delete_error: 'Error deleting project',
    created: 'Project created',
    created_description: 'The project has been created successfully.',
    create_error: 'Error creating project',
    updated: 'Project updated',
    updated_description: 'The project has been updated successfully.',
    update_error: 'Error updating project',
    archive: 'Archive',
    status: {
      all: 'All Status',
      draft: 'Draft',
      published: 'Published',
      published_flag: 'Published (flag)',
      withApplicants: 'With applicants',
      closed: 'Archived',
      completed: 'Completed',
      idea: 'Idea',
      validation: 'Validation',
      committee: 'Committee',
      active: 'Active',
      archived: 'Archived',
      legacy: 'Legacy',
      inProgress: 'In progress',
      standby: 'Standby',
      discarded: 'Discarded',
      readyToDeploy: 'Ready to deploy',
      deployed: 'Deployed',
    },
    statusReason: {
      prompt: 'Why are you setting this status?',
      placeholder: 'Reason…',
    },
    deploy: {
      cta: 'Deploy',
      confirmTitle: 'Deploy this project?',
      confirmBody: 'This marks the project as deployed. Deployed is final — the status cannot be changed afterwards.',
    },
    strategy: {
      title: 'strategy',
      autosaveHint: 'Autosaves on blur',
      placeholder: 'Write the strategy for this project: positioning, differentiators, priorities, risks…',
    },
    sections: {
      basic: 'A) Basic Information',
      detail: 'B) Briefing of Project Detail',
      milestones: 'Milestones',
      targeting: 'C) Targeting',
      scoring: 'D) Scoring',
      publication: 'E) Publication',
    },
    startupContacts: {
      title: 'Startup Outreach',
      description:
        'Track manual outreach to startups surfaced by the approved solutions. Status is updated as conversations progress.',
      addFromList: 'Add from list',
      addNew: 'Add new',
      addNewDisabledHint: 'Brand-new startup intake is coming soon',
      pickerTitle: 'Add startup from candidate list',
      pickerTitleScoped: 'Add startup to "{{title}}"',
      pickerDescription:
        "Candidates are the startups pinned across this project's approved solutions. Already-added startups are filtered out.",
      pickerDescriptionScoped:
        "Candidates are the startups pinned to this solution. Already-added startups are filtered out.",
      searchPlaceholder: 'Search candidates...',
      noCandidates: 'No candidate startups available.',
      noMatches: 'No candidates match your search.',
      addSuccess: 'Added {{count}} startup(s)',
      addFailed: 'Failed to add {{count}} startup(s)',
      empty: 'No startups attached yet. Use "Add from list" to pull from the approved solutions.',
      notesPlaceholder: 'Conversation notes...',
      contactedAt: 'First contacted',
      showExcluded: 'Show excluded ({{count}})',
      hideExcluded: 'Hide excluded ({{count}})',
      status: {
        does_not_exist: 'Does not exist',
        pending_contact: 'Not contacted',
        negotiating: 'Negotiating',
        agreed: 'Confirmed',
        dropped: 'Discarded',
      },
    
      seedBadge: 'Created from',
      seedHint: 'Seed startup — guided the AI when this solution was created. Can\'t be removed.',
      seedNotRemovable: 'The seed startup can\'t be removed.',
      noCandidatesHint: 'No remaining candidate startups',
      addNewTitle: 'Add new startup',
      addNewDone: 'Startup processed',
      addNewStarted: 'Startup added — extracting dimensions…',
      addNewDesc: 'Adds the startup to the dealflow and runs 2DS scoring + one-pager generation in the background.',},
    startupKanban: {
      title: 'startup outreach.',
      description:
        'Grouped by solution. Drag a startup across the board as the conversation moves forward — status is saved instantly.',
      empty: 'No startups yet. Use "Add from list" to pull from the approved solutions.',
      drag: 'Drag to change status',
      toggleNotes: 'Notes',
      discard: 'Discard',
      restore: 'Restore',
    },
    fields: {
      title: 'Project Title',
      sector: 'Sector',
      status: 'Status',
      short_description: 'Short Description',
      problem_context: 'Problem / Context',
      solution_proposal: 'Proposed Solution',
      scope_deliverables: 'Scope and Deliverables',
      estimated_duration: 'Estimated Duration',
      target_roles: 'Target Roles',
      seniority_min: 'Minimum Seniority (years)',
      is_published: 'Publish Project',
      project_type: 'Project Type',
      vertical: 'Vertical',
      years: 'years',
      publish_description: 'Published projects are visible to entrepreneurs and trigger matching',
    
      sector_placeholder: 'Select sector',},
    seniority_scale: {
      entry: 'Entry',
      five: '5 years',
      ten: '10 years',
      fifteen: '15+ years',
    },
    scoring: {
      urgency: 'Urgency',
      difficulty: 'Difficulty',
      priority_score: 'Priority Score',
      bucket: 'Bucket',
    },
    generate: {
      button: 'Generate Projects',
      generating: 'Generating...',
      success: 'Projects Generated',
      success_description: '{{count}} projects created from approved solutions',
      error: 'Error generating projects',
    },
    stats: {
      total: 'Total',
      published: 'Published',
      withApplicants: 'With Applicants',
      closed: 'Closed',
      timeToPublish: 'Time-To-Publish',
      timeToPublishDesc: 'Average time from creation to publication',
      timeToFirstApplicant: 'Time-To-First-Applicant',
      timeToFirstApplicantDesc: 'Average time from publication to first application',
      timeToClose: 'Time-To-Close',
      timeToCloseDesc: 'Average time from creation to close',
      timeToApplicant: 'Avg Time-To-Applicant',
    
      strategicBet: 'Strategic Bet',},
    buckets: {
      all: 'All Buckets',
      quickWin: 'Quick Win',
      strategicBet: 'Strategic Bet',
      maintain: 'Maintain',
      defer: 'Defer',
    },
    filters: {
      statusFilter: 'Status Filter',
      priorityBucket: 'Priority Bucket',
      clearFilters: 'Clear filters',
    
      sector: 'Sector',
      title: 'Filters',},
    actions: {
      viewDetails: 'View Details',
      edit: 'Edit',
      delete: 'Delete',
      save: 'Save Changes',
      findEntrepreneurs: 'Find Entrepreneurs',
    },
    list: {
      assets: 'Assets',
      assetsGenerated: 'generated',
      assetsMissing: 'not generated',
      clients: 'Clients',
      priority: 'Priority:',
      created: 'Created',
      items: 'items',
      errorLoading: 'Error loading projects: {{message}}',
    },
    matching: {
      confirm: 'Find matching entrepreneurs for "{{title}}"? This may update existing matches.',
      distribution: 'Match Quality Distribution',
      sort: 'Sort',
      sortScore: 'Score',
      sortName: 'Name',
      sortStarredScore: 'Starred + Score',
      sortStarredName: 'Starred + Name',
      applications: 'Applications',
      noApplications: 'No applications yet.',
      applicationsHint: 'Entrepreneurs who apply will appear here.',
      allMatches: 'All Matches',
      noMatches: 'No matches found for this project.',
      publishHint: 'Publish the project to trigger entrepreneur matching.',
      allApplied: 'All matched entrepreneurs have applied.',
      preview: {
        title: 'Matched Entrepreneurs',
        publishRequired: 'Publish this project to find matching entrepreneurs',
        matching: 'Matching...',
        refreshMatches: 'Refresh',
        runMatching: 'Find Matches',
        noMatches: 'No matches yet. Click "Find Matches" to search for entrepreneurs.',
        showing: 'Showing {{shown}} of {{total}} matches',
      },
      dialog: {
        confirmTitle: 'Find Matching Entrepreneurs',
        existingMatchesWarning: 'Existing matches will be removed and replaced',
        startMatching: 'Start Matching',
        matchingTitle: 'Finding Entrepreneurs',
        matchingDescription: 'Searching and scoring candidates...',
        pleaseWait: 'This may take a moment. Please wait...',
        successTitle: 'Matching Complete',
        successDescription: 'Successfully found matching entrepreneurs.',
        matchesFound: 'entrepreneurs matched',
        viewMatches: 'View Matches',
        errorTitle: 'Matching Failed',
        errorDescription: 'An error occurred while finding matches.',
        retry: 'Try Again',
      
        confirmDescription: 'This will search for entrepreneurs that match the requirements of this project.',
        confirmDescriptionUpdate: 'This will search for entrepreneurs matching this project and update existing matches.',},
    },
    publishDialog: {
      title: 'Confirm Publication',
      description: 'Review the targeting criteria before publishing. Published projects are visible to entrepreneurs and trigger matching.',
      confirm: 'Publish & Find Matches',
    },
  
    assets: {
      noLead: 'This project has no originating project lead, so there are no supporting assets.',
    },
    viewLead: 'Project Lead',
    inGaia: 'In Gaia',
    rename: {
      prompt: 'Rename project',
    },
    solutions: {
      unattached: 'Unattached startups',
      openInNewTab: 'Open solution in new tab',
      empty: 'This project has no opportunities yet. They appear once the project is materialized from its lead.',
    },
    applicants: 'applicants',
    viewCommittee: 'Committee',},

  agentProcessing: {
    defaultProcessing: 'Processing your request...',
    defaultCompleted: 'Operation completed successfully!',
    defaultError: 'An error occurred. Please try again.',
    tryAgain: 'Try Again',
    pleaseWait: 'Please wait, this may take a few moments...',
    completed: 'Completed',
    error: 'Error',
    minimize: 'Minimize',
  
    progress: 'Progress',
    continue: 'Continue',
    completedMessage: 'Processing completed successfully.',
    completedTitle: 'Processing Complete',},

  backgroundTask: {
    completed: 'Completed',
    failed: 'Failed',
    clickToView: 'Click to view',
    processing: 'Processing',
    runningInBackground: 'Running in background',
    unknownError: 'Unknown error',
    taskFailed: 'Background task failed',
    taskLost: 'Background task lost',
  },

  solution: {
    aiContext: 'Extra data',
    generatingReport: 'Generating Solution Report',
    generatingReportDescription: 'Searching for matching startups and analyzing fit...',
    searchingStartups: 'Searching and analyzing Chinese startups...',
    reportGenerated: 'Report generated successfully!',
    regenerateReport: 'Regenerate Report',
    generateReport: 'Generate Report',
    reportReady: 'Report Ready',
    devalidate: 'Remove from pending approval',
    validate: 'Validate',
    details: 'Solution Details',
    technology: 'Technology',
    operation: 'Operation',
    scope: 'Scope',
    businessModel: 'Business Model',
    solutionScore: 'Solution Score',
    matchingStartups: 'Matching Startups',
    documentView: {
      selectedStartups: 'Selected startups',
      problem: 'P',
      solution: 'S',
      transferability: 'T',
      problemFull: 'Problem fit',
      solutionFull: 'Solution fit',
      transferabilityFull: 'Transferability',
      overall: 'Overall fit',
      addNewStartup: 'Add new startup',
    
      noStartupsSelected: 'No startups selected. Use Add startups to link some.',
      addStartupsDescription: 'Search for startups to add to this solution. No regeneration is triggered.',
      addStartupsTitle: 'Add startups',},
    searched: 'searched',
    analyzed: 'analyzed',
    noStartupsFound: 'No matching startups found',
    noReportYet: 'No report generated yet',
    clickGenerateReport: 'Click "Generate Report" to search for matching Chinese startups',
    overall: 'Overall',
    problemFit: 'Problem Fit',
    solutionFit: 'Solution Fit',
    transferability: 'Transferability',
    keyEvidence: 'Key Evidence',
    problemFitAnalysis: 'Problem Fit Analysis',
    solutionFitAnalysis: 'Solution Fit Analysis',
    transferabilityAnalysis: 'Transferability Analysis',
    onepagerData: 'Startup Onepager',
    identity: 'Identity',
    valueProposition: 'Value Proposition',
    marketPosition: 'Market Position',
    businessModelBlock: 'Business Model',
    teamIp: 'Team & IP',
    contact: 'Contact & Partnerships',
    evidence: 'Evidence',
    startupReference: 'Startup Reference',
    opportunityAlignment: 'Opportunity Alignment',
    scoreBreakdown: 'Score Breakdown',
    role: 'Role',
    proof: 'Proof',
    problem: 'Problem',
    icp: 'ICP',
    constraintsAddressed: 'Constraints Addressed',
  
    coreFields: 'Solution',
    panels: {
      editSolution: 'edit solution',
    },
    evidenceCitations: 'Evidence citations',
    bands: {
      aligned: 'Aligned startups',
      suggestions: 'Suggestions',
      noneAligned: 'No startups are 100% aligned with the solution — these might interest you.',
    },
    startupItemType: 'startup',
    addStartups: 'Add startups',
    noMatchedStartupsHint: 'No startups linked yet — add some to anchor this solution.',
    startupsCount: '{{count}} linked',
    summary: 'Summary',
    deleteConfirmDescription: 'This permanently removes the solution. Committee decisions on it will be lost.',
    deleteConfirmTitle: 'Delete solution?',
    untitled: 'Untitled solution',
    analyzing: 'Analyzing opportunity context...',
    generatingBulkDescription: 'AI is generating solutions for this opportunity...',
    generatingBulk: 'Generating Solutions',},

  editor: {
    markdownField: 'Notes',
    expand: 'Expand',
    autosavesOnBlur: 'Autosaves on blur',
    characterCount: '{{count}} characters',
  },

  projectDocuments: {
    title: 'Generated documentation',
    subtitle: 'Documents the platform writes from the project data.',
    brief: 'Project Brief',
    briefDescription:
      'Full memo for investors and stakeholders: the problem, the evidence, the proposed approach and what is still open.',
    profile: 'Project Profile',
    profileDescription:
      'Two-page version of the brief, for entrepreneurs and builders.',
    brochure: 'Brochure',
    brochureDescription:
      'Single-page image laid out against the brand board, for sharing the project at a glance.',
    availableIn: 'Available in {{langs}}',
    noneYet: 'No documentation generated yet.',
    generatedMeta: 'Last generated · {{date}}',
    downloadBranding: 'Download brand board',
    generate: 'Generate documentation',
    regenerate: 'Regenerate documentation',
    generatingTitle: 'Generating documentation',
    generatingDesc:
      'Writing the brief, then laying out the profile and the brochure from it.',
    working: 'Generating the documentation…',
    brandImage: 'Brand image',
    uploadImage: 'Upload image',
    brandReuseHint: 'Leave empty to reuse the last uploaded brand board.',
    brandRequiredHint:
      'A brand board is required: the brochure is laid out against it.',
    regenerateHint:
      'Regenerating replaces the stored documents in every language.',
    allLanguagesHint:
      'The three documents are generated in English. Choose another language from a document’s download menu to translate and cache it on demand.',
  },

  comments: {
    title: 'Comments',
    add: 'Add comment',
    placeholder: 'Write a comment…',
    empty: 'No comments yet.',
    loading: 'Loading comments…',
    itemType: 'comment',
  },

  documents: {
    preparing: 'Preparing document...',
    rendering: 'Rendering this language...',
    downloading: 'Downloading...',
  },
  common: {
    dateTime: {
      datePlaceholder: 'Pick a date',
      timePlaceholder: 'Pick a time',
      timezoneNoteBrowser: 'Times are in your timezone',
    },
    select: 'Select',
    expand: 'Expand',
    collapse: 'Collapse',
    pickerCreateHint:
      'not in the list — create it from scratch and its profile will be generated automatically',
    pickerCreateBadge: 'new entry',
    backToResults: 'Back to results',
    created: 'Created',
    hide: 'Hide',
    lastUpdated: 'Last Updated',
    cancel: 'Cancel',
    save: 'Save',
    create: 'Create',
    saving: 'Saving...',
    working: 'Working...',
    generateWithAI: 'Generate with AI',
    update: 'Update',
    items: 'items',
    view: 'View',
    edit: 'Edit',
    delete: 'Delete',
    approve: 'Approve',
    reject: 'Reject',
    report: 'Report',
    generate_report: 'Generate Report',
    validate: 'Validate',
    devalidate: 'Remove from pending approval',
    error: 'Error',
    backTo: 'Back to {{name}}',
    noDataAvailable: 'No Data Available',
    sections: 'sections',
    sources: 'sources',
    expandAll: 'Expand all',
    collapseAll: 'Collapse all',
    back: 'Back',
    unknown: 'Unknown',
    close: 'Close',
    generate: 'Generate',
    remove: 'Remove',
    showLess: 'Show Less',
    showMore: 'Show More',
    title: 'Title',
    add: 'Add',
    unknown_error: 'Unknown error',
    process: 'Process',
    processing: 'Processing...',
    generating: 'Generating...',
    export: 'Export',
    upload: 'Upload',
    refresh: 'Refresh',
    copy: 'Copy',
    open: 'Open',
    filters: 'Filters',
    submit: 'Submit',
    submitting: 'Submitting...',
    optional: '(optional)',
    unlink: 'Unlink',
    searchMarketInsights: 'Search market insights...',
  
    updated: 'Updated',
    saveChanges: 'Save Changes',
    creating: 'Creating…',
    fieldOptional: '(optional)',
    fieldRequired: 'Required',
    sector: 'Sector',
    name: 'Name',
    actions: 'Actions',
    no_items: 'No items added yet.',
    link: 'Link',
    search: 'Search...',
    no_matches: 'No items match your search.',
    no_results: 'No results.',
    search_min_chars: 'Type at least {{count}} characters to search.',
    download: 'Download',
    loading: 'Loading...',
    done: 'Done',
    approved: 'approved',
    new: 'New',
    all: 'All',
    yes: 'Yes',
    add_n: 'Add ({{count}})',
    n_selected: '{{count}} selected',
    select_all: 'Select all',
    select_none: 'Clear selection',},


  units: {
    days: 'days',
    months: 'mo',
    cases: 'cases',
    practices: 'practices',
    sources: 'sources',
    integrations: 'integrations',
  },

  labels: {
    target: 'Target',
    delta: 'Delta',
    ttv: 'TTV',
  },

  stats: {
    score: 'Score',
    solutions: 'Solutions',
    ttv: 'TTV',
    payback: 'Payback',
    files: 'Files',
    opportunities: 'Opportunities',
    solutionLines: 'Solution Lines',
    references: 'References',
    icp: 'ICP',
    kpi: 'KPI',
    urgency: 'Urgency',
  },

  tooltips: {
    scoreTooltip: 'Overall score based on fit, feasibility, and potential',
    solutionsTooltip: 'Number of solutions for this thesis',
    ttvTooltip: 'Estimated time to value in days',
    paybackTooltip: 'Estimated payback period in months',
    filesUploaded: 'Documents uploaded for analysis',
    opportunitiesIdentified: 'Investment opportunities identified from analysis',
    solutionLinesCreated: 'Solution lines (theses) created for opportunities',
    referencesTooltip: 'External references and citations from the report',
    icpDefined: 'Ideal Customer Profile defined',
    kpiTooltip: 'Current problem KPI',
    urgencyTooltip: 'Market urgency score',
    solutionsDefined: 'Solution lines defined for this opportunity',
    marketUrgency: 'Market Urgency',
    timeSensitivity: 'Time sensitivity of this opportunity',
    totalInsights: 'Total number of market research insights created',
    draftInsights: 'Insights created but not yet processed',
    processingInsights: 'Insights currently being analyzed by AI',
    runningInsights: 'Insights currently being analyzed by AI',
    completedInsights: 'Analysis complete, report available',
    failedInsights: 'Last run failed; no report produced',
    validatedInsights: 'Insights reviewed and validated',
    withOpportunities: 'Insights that have extracted opportunities',
  },

  overview: {
    totalInsights: 'Total Insights',
    draft: 'Draft',
    processing: 'Running',
    running: 'Running',
    validated: 'Completed',
    completed: 'Completed',
    failed: 'Failed',
    hoverForDetails: 'Hover over indicators for details',
    dataProgress: 'Data progress: Files → Report',
    validatedStatus: 'Validated',
    marketWindow: 'Market Window',
    urgency: 'urgency',
    constraints: 'Constraints',
    data: 'Data',
    compliance: 'Compliance',
    it: 'IT',
    successObjective: 'Success Objective',
    targetKpi: 'Target KPI',
    expectedImprovement: 'Expected Improvement',
    benchmarkGap: 'Benchmark Gap',
    notableCases: 'Notable Cases',
    gapComparison: 'Gap Comparison',
    saveMinutes: 'Save Minutes',
    generatingPostReport: 'Generating Post-Committee Report',
    problem: 'Problem',
    targetIcp: 'Target ICP',
    keyRoles: 'Key roles',
    ttv: 'TTV',
    payback: 'Payback',
    solutionLine: 'solution line',
    solutionLines: 'solution lines',
    solutions: 'solutions',
    unsavedChanges: 'You have unsaved changes',
    competition: 'Competition',
    valueProposition: 'Value Proposition',
    marketSize: 'Market Size',
    risks: 'Risks',
    size: 'Size',
    kpi: 'KPI',
  
    chinaBenchmark: 'China benchmark',
    problemStatement: 'Problem statement',
    operation: 'Ops',
    businessModel: 'Model',
    scope: 'Scope',
    technology: 'Tech',
    legend: 'Legend',},

  risks: {
    technical: 'technical',
    operational: 'operational',
    market: 'market',
    mitigations: 'mitigations',
    barriersIdentified: '{{count}} barriers identified',
    strategiesDefined: '{{count}} strategies defined',
    similarCases: 'similar cases',
    payback: 'payback',
  },

  urgencyLevels: {
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    critical: 'Critical',
  },

  evaluation: {
    title: 'Opportunity Evaluation',
    subtitle: 'Route approved opportunities into project leads.',
    approved: 'Approved Opportunities',
    approve: 'Approve',
    reject: 'Reject',
    sendToShaping: 'Send to Shaping',
    queued: 'Queued for Review',
    urgency: 'Urgency',
    urgent: 'Urgent',
    fit: 'Strategic Fit',
    sponsor: 'Sponsor',
    solutionsLabel: 'Solutions',
    unassigned: 'Unassigned',
    solutions_one: '{{count}} solution',
    solutions_other: '{{count}} solutions',
    empty: 'No approved opportunities for this committee yet.',
    approvedToast: 'Opportunity approved',
    rejectedToast: 'Opportunity rejected',
    sentToast: 'Approved — opening shaping',
    failed: 'Action failed',
  },
  shaping: {
    title: 'Shaping',
    subtitle: 'Group approved opportunities into project leads',
    inbox: 'Inbox / Unassigned',
    newLead: 'New Container',
    createLeadTitle: 'New Project Lead',
    createLeadDesc: 'Create a shaping container for approved opportunities.',
    name: 'Name',
    namePlaceholder: 'e.g. Q3 Global Expansion Strategy',
    objective: 'Core Objective',
    objectivePlaceholder: 'What is this lead shaping toward?',
    sector: 'Sector',
    create: 'Create',
    creating: 'Creating…',
    noMatches: 'No opportunities match your search.',
    dropHint: 'Add opportunities to merge into this lead',
    mergeDropHint: 'Drag opportunities here to merge into {{title}}',
    activeContainer: 'Active Container',
    constituents: 'Constituent Opportunities',
    solutions_one: '{{count}} solution',
    solutions_other: '{{count}} solutions',
    opportunities_one: '{{count}} opportunity',
    opportunities_other: '{{count}} opportunities',
    noLeads: 'No project leads yet. Create one to start shaping.',
    emptyLead: 'No opportunities yet.',
    unassignedEmpty: 'No unassigned approved opportunities.',
    remove: 'Remove from lead',
    view: 'Open lead',
    mergeReadiness: 'Merge Readiness',
    generateOnePager: 'Generate One-Pager',
    deleteLead: 'Delete lead',
    createdToast: 'Project lead created',
    deletedToast: 'Project lead deleted',
    deleteLeadFailed: 'Could not delete the project lead',
    addFailed: 'Could not add opportunity',
    moveTo: 'Move to lead',
    moveToNew: 'New lead with this',
    movedToast: 'Moved to lead',
    viewOpportunity: 'View opportunity',
    notFound: 'Project lead not found',
    regenerate: 'Regenerate',
    exportPdf: 'Export PDF',
    exportImage: 'Export Image',
    onePager: 'One-Pager',
    onePagerEmpty: 'No one-pager yet — generate it from the header.',
    onePagerReady: 'One-pager ready',
    committeeFeedback: 'Committee feedback',
    editOpportunity: 'Edit opportunity',
    editSolution: 'Edit solution',
    viewSolution: 'Open solution',
    referenceCases: 'Reference cases',
    addSolution: 'Add solution',
    solutionItemType: 'solution',
    createSolutionTitle: 'Creating solution',
    createSolutionDesc: 'AI is generating the full solution from your input…',
    createSolutionFailed: 'Could not create solution',
    generateSolutions: 'Generate solutions',
    generatingSolutions: 'Generating solutions',
    generatingSolutionsDesc: 'AI is generating solutions for this opportunity…',
    generateSolutionsFailed: 'Could not generate solutions',
    technicalSpecs: 'Technical specifications',
    downloadPdf: 'Download PDF',
    specPdf: {
      generating: 'Generating PDF',
      generatingDesc: 'Translating and rendering the spec sheet…',
    },
    technicalSpecsPlaceholder: 'Add technical specifications (open text)',
    technicalSpecsExpandedPlaceholder: 'Write the technical specifications here…',
    onePagerGeneratedAt: 'Generated {{date}}',
    onePagerGenerating: {
      title: 'Generating one-pager',
      desc: 'Composing copy and creating the visual one-pager from this lead.',
      status: 'Generating one-pager...',
    },
    finalized: 'Finalized',
    finalize: 'Approve & Create Project',
    finalizeConfirm: 'Approve this lead? This creates a Project with the lead’s data, ready to run startup outreach and manage assets. The lead is then locked.',
    finalizeAction: 'Approve',
    finalizedToast: 'Approved — project created',
    finalizeFailed: 'Could not approve project lead',
    reject: 'Reject',
    rejectConfirm: 'Reject this project lead? It will be archived.',
    rejectedToast: 'Project lead rejected',
    lifecycle: {
      opportunity: 'Opportunity',
      committee: 'Committee',
      lead: 'Project Lead',
      project: 'Project',
    },
    viewProject: 'View Project',
    solutions: {
      empty:
        'This project has no opportunities yet. They appear once the project is materialized from its lead.',
    },
    assets: {
      title: 'Supporting Assets',
      upload: 'Upload',
      empty: 'No supporting assets yet.',
      emptyFolder: 'This folder is empty — drag files here to upload.',
      delete: 'Delete asset',
      deleteFolder: 'Delete folder',
      deleteFolderConfirm: 'Delete "{{name}}" and everything in it?',
      dropToFolder: 'Drop the files to upload them to “{{folder}}”',
      dragHint: 'Drag documents onto this area to upload them, or use “Upload”.',
      uploadQueue: {
        running: 'Uploading… {{done}} of {{total}}',
        finished: '{{done}} uploaded · {{failed}} failed',
        clear: 'Clear',
        dismiss: 'Remove from list',
      },
      uploadErrors: {
        tooLarge: 'The file is too large to upload.',
        interrupted: 'The upload was interrupted (slow connection or very large file). Please try again.',
      },
      deletedToast: 'Asset deleted',
      uploadFailed: 'Upload failed',
      moveTo: 'Move to folder',
      rootFolder: 'Root',
      preview: 'Preview',
      selectToPreview: 'Select a file to preview it here.',
      noInlinePreview: 'No inline preview for this file type.',
      previewFailed: 'Could not load the preview.',
      uploadTarget: 'Uploading to',
      newFolder: 'New folder',
      folderName: 'folder name',
    },
    voucher: 'Visual Voucher',
    generateVoucher: 'Generate Voucher',
    voucherEmpty:
      'Generate a fully visual one-pager. Uploaded images are used as brand references for the hero visual.',
    voucherHeroAlt: 'Voucher hero visual',
    voucherGenerating: {
      title: 'Generating voucher',
      desc: 'Composing copy, creating the hero visual and rendering the PDF.',
      status: 'Generating voucher...',
    },
    outreach: {
      title: 'Startup Outreach',
      empty:
        'Track which startups have been contacted for this lead. Starting outreach prepares the draft project and seeds candidate startups from the approved solutions.',
      start: 'Start Outreach',
      readyToast: 'Startup outreach is ready',
    },
    startups: {
      title: 'Startups',
      label: 'Startups / Partners',
      add: 'Add Startup',
      itemType: 'startup',
      empty:
        'Start outreach to manage startups for this lead — add existing or brand-new startups (dealflow + 2DS + one-pager).',
    },
    assembly: {
      solutionsHeading: 'Solutions',
      noSolutions: 'No solutions yet.',
      assign: 'Assign',
      assignTo: 'Assign to Project Lead',
      prev: 'Previous',
      next: 'Next',
      toAssign: '{{count}} to assign',
      assignedSummary: '{{assigned}} in {{leads}} leads',
      close: 'Close post-committee',
      closeHint: '{{count}} still to assign',
      closedToast: 'Post-committee completed',
      assigned: 'Assigned',
      assignedTo: 'Assigned to {{lead}}',
      unassign: 'Remove',
    },
    split: {
      title: 'Split Project Lead',
      action: 'Split',
      cta: 'Split',
      desc: 'Allocate the solutions of "{{title}}" into separate child leads.',
      dndDesc: 'Drag solutions into the new lead. The original lead keeps whatever stays on the left.',
      keepBox: 'Original lead keeps',
      moveBox: 'New lead',
      newName: 'New lead name',
      needTwo: 'A lead needs at least two solutions to split.',
      targets: 'Target Structure',
      addTarget: 'Add Target',
      solutions: 'Available Solutions',
      unassigned: 'Unassigned',
      noSolutions: 'No approved solutions to allocate.',
      confirm: 'Confirm Split',
      needAllocation: 'Allocate at least one solution to a target.',
      done: 'Split into a new opportunity',
      failed: 'Could not split opportunity',
    },
    merge: {
      action: 'Merge',
      title: 'Merge Project Leads',
      dndDesc: 'Combine two same-sector project leads into one. All opportunities and solutions move into the new lead, and the other is deleted.',
      pickSecond: 'Select a lead to merge in',
      result: 'New project lead',
      noCandidates: 'No other same-sector draft leads to merge with.',
      confirm: 'Merge',
      done: 'Project leads merged',
      failed: 'Could not merge project leads',
    },
    archives: {
      title: 'Archives',
      subtitle: 'Finalized project leads',
      empty: 'No finalized project leads yet.',
      view: 'View',
    },
    lineage: {
      split: 'Split',
      merged: 'Merged',
    },
    assignHint: 'Drag onto a project lead to assign',
    postCommittee: {
      title: 'Post-Committee',
      subtitle: 'Review a closed committee and shape its opportunities into leads',
      workspaceSubtitle: 'Group, split and assign this committee’s opportunities into project leads',
      assembleSubtitle: 'Split, merge and assign approved opportunities into project leads',
      committee: 'Committee',
      pick: 'Select committee',
      reviewHeading: 'Review',
      shapeHeading: 'Shape into Project Leads',
      empty: 'No committees are ready for post-committee review yet.',
    },
    projectLeads: {
      title: 'Project Leads',
      subtitle: 'All shaping containers across committees',
      empty: 'No project leads yet. Create them from a post-committee workspace.',
      noMatches: 'No project leads found',
      searchPlaceholder: 'Search project leads…',
      count_one: '{{count}} item',
      count_other: '{{count}} items',
      view: 'View',
      filter: {
        all: 'All',
      },
      status: {
        inProgress: 'In progress',
        standby: 'Stand by',
        discarded: 'Discarded',
        convertedToProject: 'Converted to Project',
      },
    
      count: '{{count}} items',},
    statusReason: {
      label: 'Reason',
      prompt: 'Why are you setting this status?',
      placeholder: 'Reason…',
    },
    opp: {
      new: 'New Opportunity',
      title: 'New Opportunity',
      desc: 'Create an approved opportunity, ready to assign during shaping.',
      name: 'Title',
      namePlaceholder: 'e.g. Predictive maintenance for turbines',
      vertical: 'Vertical',
      verticalPlaceholder: 'Industry / vertical (optional)',
      createdToast: 'Opportunity created',
      failed: 'Could not create opportunity',
    },
  
    noSolutions: 'No solutions yet.',},
  startups: {
      noUpdates: 'No updates',
      pendingNew_other: '{{count}} new',
      pendingNew_one: '{{count}} new',
      taskOpportunityTitle: 'Opportunity: {{name}}',
      errorLoading: 'Error loading startups: {{message}}',
    pageTitle: 'Startup Intelligence',
    subtitle: 'Structured company profiles with AI-extracted insights',
    backToStartups: 'Back to Startups',
    startupNotFound: 'Startup not found',
    noDataYet: "This startup doesn't have any analysis data yet.",
    processingStatus: 'Processing',
    scopedBy: 'scoped by',
    allSectors: 'all sectors',
    scopeBySector: 'Filter by sector',
    scoreDetails: 'Score details',
    scoreBreakdown: 'Score breakdown',
    scoreFormula: 'Formula',
    noScoreBreakdown: 'No per-dimension breakdown available for this match.',
    marketInsightOverallScoreCaption: 'Final AI-reranked relevance score',
    rawDimensionScores: 'Raw semantic similarity per dimension',
    dimensions: {
      combined: 'Raw semantic score (undifferentiated)',
      problem_market: 'Problem & market',
      business_execution: 'Business & execution',
    },
    solutionScoreFormula: 'overall = weighted blend of problem fit, solution fit and transferability (0–100 each), scored by the solutions agent.',
    toasts: {
      generatingOpportunity: 'Generating opportunity from onepager…',
      generateOpportunityFailed: 'Failed to start generation',
    },
    stats: {
      totalStartups: 'Total Startups',
      completeProfiles: 'Complete Profiles',
      simplified: 'Simplified',
      pending: 'Pending',
    },
    filters: {
      profileStatus: 'Profile Status',
      allProfiles: 'All Profiles',
      allSectors: 'All Sectors',
      industrySector: 'Industry Sector',
      searchByName: 'Search by name...',
      showingOf: 'Showing {{count}} of {{total}}',
      clear: 'Clear',
      noStartupsFound: 'No startups found',
      clearFilters: 'Clear filters',
    },
    delete: {
      failed: 'Could not delete the startup',
      processing: 'The startup cannot be deleted while it is being processed.',
      detachWarning: 'Deleting it removes the startup from: {{usages}}.',
      usedByOtherOrgs: 'It cannot be deleted: {{count}} records in other organizations use this startup.',
      usage: {
        opportunities: 'opportunities ({{names}})',
        project_leads: 'project leads ({{names}})',
        projects: 'projects ({{names}})',
        other_organizations: '{{count}} records in other organizations',
      },
    },
    actions: {
        generateOpportunity: 'Generate opportunity',
      viewProfile: 'View Profile',
      vectorize: 'Vectorize',
      generateOnepager: 'Generate OnePager',
    
      regenerateOnepager: 'Regenerate OnePager',
      generate2ds: 'Generate 2DS',
      regenerate2ds: 'Regenerate 2DS',
      createOpportunity: 'create opportunity',},
    vectorizing: {
      title: 'Vectorizing startup',
      desc: 'Extracting dimensions and storing vectors so this startup is searchable…',
      status: 'Running dimension extraction',
    },
    onepagerGenerating: {
      title: 'Generating OnePager',
      desc: 'Building the full 6-block onepager via web search + LLM…',
      status: 'Running onepager agent',
    },
    tabs: {
      content: 'Analysis',
      assets: 'Assets',
    },
    badges: {
        noProfile: 'No Profile',
      validated: 'Validated',
      draft: 'Draft',
      inProgress: 'In Progress',
      failed: 'Failed',
      completeOnePager: 'Complete One-Pager',
      simplifiedAnalysis: 'Simplified Analysis',
      currentData: 'Current Data',
      fullAnalysis: 'Full Analysis',
    },
    contactPerson: {
      title: 'Contact person',
      name: 'Name',
      role: 'Role',
      email: 'Email',
      phone: 'Phone',
      empty: 'No contact person yet — add one with Edit.',
    },
    problemMarket: {
      editTitle: 'Edit problem & solution',
      enrichedContent: 'Summary',
      whatProblem: 'What problem it solves',
      howItSolves: 'How it solves it',
      onePerLine: 'One item per line',
    },
    sections: {
      simplifiedAnalysis: 'Simplified Analysis (2D)',
      completeOnePager: 'Complete One-Pager',
      problemMarketAnalysis: 'problem & solution',
      industryVerticals: 'Industry Verticals',
      businessExecutionAnalysis: 'Business-Execution Analysis',
      companyIdentity: 'Company Identity & Status',
      valueProposition: 'Value Proposition & Solution',
      marketPosition: 'Market Position & Competition',
      businessModel: 'Business Model',
      teamIp: 'Team & Intellectual Property',
      technologyStack: 'Technology Stack',
      contactPartnerships: 'Contact & Partnerships',
      dataQuality: 'Data Quality Assessment',
      references: 'Data Sources & References',
      linkageSubgraph: 'Linkage Subgraph',
      verification: 'Verification',
      pipelineMetadata: 'Pipeline Metadata',
    
      source: 'source',
      contact: 'Contact',},
    verification: {
      sourceValidated: 'Source Validated',
      crossReferenced: 'Cross-Referenced',
      crossReferencedDesc: 'Corroborated across {{count}} external source(s).',
      extractionVerified: 'Extraction Verified',
    },
    fields: {
      generationModel: 'Generation Model',
      marketUrgency: 'Market Urgency',
      marketSize: 'Market Size',
      problemSeverity: 'Problem Severity',
      revenueStreams: 'Revenue Streams',
      technologyStack: 'Technology Stack',
      primaryProblem: 'Primary Problem',
      targetMarket: 'Target Market',
      painPoints: 'Pain Points',
      industryVerticals: 'Industry Verticals',
      geographicalFocus: 'Geographical Focus',
      businessModel: 'Business Model',
      fundingStage: 'Funding Stage',
      yearEstablished: 'Year Established',
      keyCustomers: 'Key Customers',
      keywords: 'Keywords',
      chineseName: 'Chinese Name',
      englishName: 'English Name',
      foundationYear: 'Foundation Year',
      location: 'Location',
      status: 'Status',
      registrationCode: 'Registration Code',
      problemAddressed: 'Problem Addressed',
      solutionFramework: 'Solution Framework',
      valueProposition: 'Value Proposition',
      productsServices: 'Products/Services',
      industriesServed: 'Industries Served',
      marketSegment: 'Market Segment',
      targetCustomer: 'Target Customer',
      marketTrends: 'Market Trends',
      competitiveLandscape: 'Competitive Landscape',
      growthOpportunities: 'Growth Opportunities',
      revenueModel: 'Revenue Model',
      monetizationStrategy: 'Monetization Strategy',
      fundingRound: 'Funding Round',
      fundingAmount: 'Funding Amount',
      keyInvestors: 'Key Investors',
      keyMetrics: 'Key Metrics',
      ceoFounder: 'CEO/Founder',
      founderBackground: 'Founder Background',
      teamSize: 'Team Size',
      keyTeamMembers: 'Key Team Members',
      patentsIp: 'Patents & IP',
      coreTechnologies: 'Core Technologies',
      aiMlCapabilities: 'AI/ML Capabilities',
      infrastructure: 'Infrastructure',
      techDifferentiators: 'Technology Differentiators',
      website: 'Website',
      strategicPartnerships: 'Strategic Partnerships',
      analysisConfidence: 'Analysis Confidence',
      primarySource: 'Primary Source',
      extractionMethod: 'Extraction Method',
      generatedDate: 'Generated Date',
      usedIn: 'Used in:',
    
      added: 'added',
      discovered: 'discovered',
      source: 'source',
      article: 'article',
      link: 'link',
      origin: 'origin',},
    processing: {
      title: 'Processing Startups',
      pleaseWait: 'This may take several minutes. Please do not close this page.',
      progress: 'Progress',
      estimatedTime: '~10 minutes per 25 startups',
      errorTitle: 'Processing Failed',
      defaultError: 'An error occurred during processing.',
      tryAgain: 'Try Again',
      completedTitle: 'Processing Complete',
      completedMessage: 'All startups have been processed successfully.',
      continue: 'Continue',
      csvTitle: 'Processing CSV File',
      csvMessage: 'Extracting startup dimensions using AI...',
      onepagerTitle: 'Generating OnePagers',
      onepagerMessage: 'Creating full onepagers using GPT-5-mini...',
      insertTitle: 'Inserting Startups',
      insertMessage: 'Saving startups to database and generating embeddings...',
    },
  
    onepagerShort: 'one-pager',
    onepagerAvailable: 'One-pager available for this startup',
    linkedSectionLabel: 'Currently linked',
    pickerDescription: 'Linked startups appear first. Search to add more.',
    pickerTitle: 'Select startups',
    relevanceTooltip: 'Search relevance — name matches rank above 2D/onepager matches',
    alignmentScoreTooltip: 'Overall alignment with the solution (0–100)',
    provenance: {
      monitoring: 'source monitoring',
      import: 'imported',
      manual: 'manual entry',
    },
    generationFailed: 'Generation failed',
    generateOpportunityFailed: 'Failed to start generation',
    generatingOpportunity: 'Generating opportunity from onepager…',
    addStarted: 'Startup added — extracting dimensions…',
    addDesc: 'Creates the startup and runs 2DS scoring + one-pager generation in the background.',
    add: 'Add startup',
    createAnyway: 'Create anyway',
    sourceUrl: 'Source URL',
    cnName: 'Chinese name',
    addTitle: 'Add startup',},

  // Applications Admin
  applications: {
    pending: {
      title: 'Pending Applications',
      subtitle: 'Review and process entrepreneur applications awaiting approval',
      refresh: 'Refresh',
      cardTitle: 'Applications Pending Review',
      awaitingReview: '{{count}} application(s) awaiting review',
      noPending: 'No pending applications',
      noEmail: 'No email',
      profile: 'Profile',
      rejectionReason: 'Rejection Reason',
      rejectionPlaceholder: 'Provide feedback for the applicant...',
      confirmRejection: 'Confirm Rejection',
      cancel: 'Cancel',
      evaluating: 'AI Evaluating',
    },
    approved: {
      title: 'Approved Applications',
      subtitle: 'Entrepreneurs who have been granted access to the platform',
      noApproved: 'No approved applications',
      noApprovedDesc: 'No applications have been approved yet',
      approved: 'Approved',
      noHeadline: 'No headline',
      approvedTime: 'Approved {{time}}',
      viewDetails: 'View Details',
    },
    rejected: {
      title: 'Rejected Applications',
      subtitle: 'Applications that have been reviewed and declined',
      noRejected: 'No rejected applications',
      noRejectedDesc: 'No applications have been rejected',
      rejected: 'Rejected',
      noHeadline: 'No headline',
      rejectedTime: 'Rejected {{time}}',
      reason: 'Reason:',
      viewDetails: 'View Details',
    },
  },

  // Founders Hub Sidebar
  foundershub: {
    sidebar: {
      title: "founder's hub",
      dashboard: 'dashboard',
      applications: 'applications',
      entrepreneurs: 'entrepreneurs',
      projects: 'projects',
    },
    projects: {
      subtitle: 'View projects and their matched entrepreneurs',
    },
    participant: {
      noAccess: 'Your account does not have access to FoundersHub.',
    },
  },

  gaia: {
    programs: {
      projectOne: '1 assigned project',
      projectCount: '{{total}} assigned projects',
      createdOn: 'Added to Gaia: {{date}}',
      title: 'programmes',
      subtitle: 'Each programme defines the phases, activities and deliverables its projects inherit.',
      new: 'New programme',
      empty: 'No programmes yet. Create the first one to start defining phases.',
      itemType: 'programme',
      publish: 'Publish',
      publishConfirm: 'The programme will move to Active status.',
      publishedToast: 'Programme published.',
      publishFailed: 'Could not publish the programme.',
      createFailed: 'Could not create the programme.',
      updateFailed: 'Could not save the programme.',
      deleteFailed: 'Could not delete the programme.',
    },
    programStatus: {
      draft: 'Draft',
      active: 'Active',
      archived: 'Archived',
    },
    programBuilder: {
      noExpert: 'No expert',
      projects: 'Assigned projects',
      projectsEmpty: 'No project is running through this programme yet.',
      phases: 'Programme phases',
      newPhase: 'New phase',
      phasesEmpty: 'This programme has no phases yet. Create the first one to lay out its journey.',
      phaseItemType: 'phase',
      moveUp: 'Move up',
      moveDown: 'Move down',
      objective: 'Objective',
      activities: 'Activities',
      newActivity: 'New activity',
      activitiesEmpty: 'This phase has no activities yet.',
      activityItemType: 'activity',
      deliverableOne: '1 deliverable',
      deliverableCount: '{{total}} deliverables',
      gate: 'Gate',
      newGate: 'New gate',
      gateEmpty: 'This phase has no gate yet. Add one so it can be closed.',
      gateItemType: 'gate',
      locked: 'This programme already has {{total}} running projects, so it cannot be modified in this version. The one thing you can still change is the expert in charge of each activity, and the change applies to every running project.',
      changeExpert: 'Change expert',
    },
    programForm: {
      newTitle: 'New programme',
      editTitle: 'Edit programme',
      description: 'A programme is the template of phases, activities and deliverables its projects inherit.',
      name: 'Name',
      namePlaceholder: 'Programme name',
      descriptionLabel: 'Description',
      status: 'Status',
      icon: 'Icon',
      removeIcon: 'Remove icon',
    },
    gateForm: {
      newTitle: 'New gate',
      editTitle: 'Edit gate',
      description: 'The gate closes the phase: the project cannot move on until it is approved.',
      name: 'Name',
      namePlaceholder: 'Gate name',
      descriptionLabel: 'Description',
      descriptionPlaceholder: 'What has to be validated to clear the phase',
    },
    projects: {
      title: 'projects',
      subtitle: 'Each project is a startup or team taking part in a programme.',
      new: 'New project',
      search: 'Search project...',
      empty: 'No projects yet. Create the first one on a configured programme.',
      noneAssigned: 'You are not assigned to any project yet.',
      itemType: 'project',
      program: 'Programme',
      phaseCount: '{{completed}}/{{total}} phases',
      createFailed: 'Could not create the project.',
      updateFailed: 'Could not save the project.',
      deleteFailed: 'Could not delete the project.',
      editLocked_one: 'This project already has one entrepreneur going through it, so its details can no longer be changed. The project coordinator can still be reassigned at any time, and the status actions (pause, complete, cancel) remain available.',
      editLocked_other: 'This project already has {{count}} entrepreneurs going through it, so its details can no longer be changed. The project coordinator can still be reassigned at any time, and the status actions (pause, complete, cancel) remain available.',
    },
    projectStatus: {
      draft: 'Draft',
      active: 'Active',
      paused: 'Paused',
      completed: 'Completed',
      cancelled: 'Cancelled',
      activateAction: 'Activate',
      pauseAction: 'Pause',
      resumeAction: 'Resume',
      completeAction: 'Complete',
      cancelAction: 'Cancel',
    },
    lifecycle: {
      blocked: 'Blocked',
      in_progress: 'In progress',
      in_review: 'In review',
      approved: 'Approved',
      rejected: 'Rejected',
      completed: 'Completed',
      enabled: 'Enabled',
      pending: 'Pending',
    },
    projectForm: {
      startedAt: 'Start date',
      startedAtHint: 'Each phase deadline is calculated from here, using the durations the program defines.',
      newTitle: 'New project',
      editTitle: 'Edit project',
      description: 'Define the project and assign the people involved.',
      name: 'Name',
      namePlaceholder: 'Project name',
      descriptionLabel: 'Description',
      status: 'Status',
      program: 'Programme',
      programPlaceholder: 'Select a programme',
      programLocked: 'The programme cannot be changed once the project has materialized it.',
    },
    activityForm: {
      expert: 'Expert responsible for the evaluation',
      expertPlaceholder: 'Choose an expert',
      removeExpert: 'Remove expert',
      expertHint: 'Default expert who validates this activity across projects. Changing it here applies to every running project.',
      changeExpertTitle: 'Change expert',
      newTitle: 'New activity',
      editTitle: 'Edit activity',
      name: 'Name',
      namePlaceholder: 'Activity name',
      descriptionLabel: 'Description',
      descriptionPlaceholder: 'What the team has to do in this activity',
      deliverables: 'Deliverables',
      addDeliverable: 'Add deliverable',
      deliverablesHint: 'Each deliverable can carry a reference document so the reviewer can compare what was expected with what was handed in.',
      noDeliverables: 'No deliverables defined yet.',
      deliverableNamePlaceholder: 'Deliverable name',
      deliverableDescriptionPlaceholder: 'Deliverable description',
      removeDeliverable: 'Remove deliverable',
      documentation: 'Documentation and templates',
      documentationHint: 'Add links (text with a hyperlink) or upload downloadable files straight from the activity.',
      noLinks: 'No links added yet.',
      linkLabelPlaceholder: 'Link text',
      addLink: 'Add link',
        invalidLink: 'Enter a valid web address (http or https).',
      removeLink: 'Remove link',
      uploadFile: 'Upload downloadable file',
      removeDocument: 'Remove file',
      saveBeforeUpload: 'The files will be uploaded when you save the activity.',
      pendingUpload: 'Will be uploaded on save',
      uploadFailed: 'Could not upload: {{files}}',
      assignees: 'Team assigned to the activity',
      noAssignees: 'Nobody is assigned to the activity yet.',
    },
    assigneePicker: {
      // "activity expert": disambiguated from the terminus committee expert
      // (UserRole.EXPERT) — the two share the word "expert" on screen but are
      // different things (§3.2).
      inviteMentor: 'Invite an activity expert',
    },
    mentorInvite: {
      hint: 'They will be invited to Gaia as a member responsible for the activity and receive an email. If they already exist in the organization, they simply gain access.',
      email: 'Email',
      fullName: 'Name',
      submit: 'Invite expert',
      error: 'The expert could not be invited.',
      title: 'Team',
      add: 'Add person',
      empty: 'Nobody is assigned yet.',
      reference: 'Mark as reference person',
      remove: 'Remove',
      pickerHint: 'People in your organisation who can take the work on.',
      searchPlaceholder: 'Search by name or email...',
      noCandidates: 'No people available.',
    },
    phaseForm: {
      deadlineOffset: 'Deadline',
      deadlineOffsetPlaceholder: 'Choose a deadline',
      deadlineOffsetHint: 'A phase\u2019s deadline is counted from the moment the previous gate closes (or the project\u2019s start date, for the first phase).',
      newTitle: 'New phase',
      editTitle: 'Edit phase',
      name: 'Name',
      namePlaceholder: 'Phase name',
      descriptionLabel: 'Description',
      objective: 'Objective',
      team: 'Team assigned to the phase',
      teamEmpty: 'Nobody assigned to the phase yet.',
    },
    phases: {
      dueDate: 'Due {{date}}',
      setDueDate: 'Set a due date',
      overdue: 'Overdue',
      editDueDate: 'Edit due date',
      manualBadge: 'Manual',
      manualHint: 'Set by hand — it no longer recalculates automatically.',
      title: 'Programme phases',
      subtitle: '{{completed}} of {{total}} phases completed',
      activityCount: '{{approved}}/{{total}} activities',
      objective: 'Phase objective',
      empty: 'This project has no programme assigned yet.',
      deadlineOffset: {
        '1w': '1 week',
        '2w': '2 weeks',
        '3w': '3 weeks',
        '4w': '4 weeks',
      },
    },
    activities: {
      title: 'Activities',
      count: '{{approved}} of {{total}} approved',
      more: 'Show more',
      less: 'Show less',
      deliverables: 'Deliverables',
      documentation: 'Other documentation',
      noDeliverables: 'No deliverables defined.',
      empty: 'This phase has no activities.',
      feedbackPlaceholder: 'Feedback for the founder...',
      submissionMessage: 'Comment for the reviewer (optional)',
      submitForReview: 'Submit activity for review',
      approve: 'Approve activity',
      reject: 'Reject',
      submissionLabel: 'Submission comment',
      feedbackLabel: "Reviewer's feedback",
      expert: 'Expert responsible for the evaluation',
      noExpert: 'Unassigned',
      enableFailed: 'Could not unlock the activity.',
      dueDateFailed: 'Could not change the due date.',
    },
    gate: {
      generateDossier: 'Generate dossier',
      dossierNotImplemented: 'not yet implemented',
      downloadDossier: 'Download dossier',
      uploadReport: 'Upload post-gate report',
      approve: 'Approve gate',
      reject: 'Reject',
      feedbackPlaceholder: "Reviewer's feedback...",
      blockedHint: 'This gate unlocks once every activity in the phase is approved.',
    },
    deliverables: {
      status: {
        pending: 'Pending',
        submitted: 'Submitted',
        approved: 'Approved',
        rejected: 'Rejected',
      },
      upload: 'Upload file',
      submit: 'Submit for review',
      approve: 'Approve',
      reject: 'Reject',
      feedbackRequired: 'Write feedback to be able to reject.',
      needsFileTooltip: 'The deliverable needs at least one file.',
      reorder: 'Reorder',
      empty: 'No files yet.',
    },
    reviewHistory: {
      title: 'Review history',
      readOnly: 'This history is read-only: it cannot be modified.',
      empty: 'No review has been requested in this phase yet.',
      activity: 'Activity',
      gate: 'Gate',
      noRequest: 'No associated request',
      submitted: 'Submitted on {{date}} by {{name}}',
      resolved: 'Resolved on {{date}} by {{name}}',
      comment: 'Comment',
      feedback: 'Feedback',
      unknownPerson: 'Unidentified',
    },
    activityLog: {
      empty: 'No activity recorded yet.',
      actions: {
        meeting_convened: 'Meeting convened',
        meeting_updated: 'Meeting updated',
        meeting_cancelled: 'Meeting cancelled',
        meeting_summary_saved: 'Meeting summary saved',
        meeting_validated: 'Meeting validated',
        file_uploaded: 'File uploaded',
        file_removed: 'File removed',
        files_reordered: 'Files reordered',
        deliverable_submitted: 'Deliverable submitted for review',
        deliverable_approved: 'Deliverable approved',
        deliverable_rejected: 'Deliverable rejected',
        activity_submitted: 'Activity submitted for review',
        activity_rejected: 'Activity rejected',
        activity_approved: 'Activity approved',
        activity_opened: 'Activity opened',
        phase_started: 'Phase started',
        phase_completed: 'Phase completed',
        gate_enabled: 'Gate enabled',
        gate_approved: 'Gate approved',
        gate_rejected: 'Gate rejected',
        post_gate_report_uploaded: 'Post-gate report uploaded',
        project_created: 'Project created',
        project_activated: 'Project activated',
        project_completed: 'Project completed',
        assignment_added: 'Person assigned',
        assignment_removed: 'Person unassigned',
        due_date_overridden: 'Due date overridden',
      },
    },
    coordinatorInvite: {
      invite: 'Invite coordinator',
      hint: 'They will be invited to Gaia as a member and receive an email. If they already belong to the organization, only the access is added.',
      email: 'Email',
      fullName: 'Name',
      submit: 'Invite coordinator',
      error: 'The coordinator could not be invited.',
    },
    coordinator: {
      title: 'Project coordinator',
      reference: 'Reference contact',
      assign: 'Assign',
      override: 'Change',
      inherited: 'Inherited from the program',
      assignTitle: 'Project coordinator',
      assignHint: "Only staff from the project's organization are listed.",
      assignError: 'The coordinator could not be assigned.',
      empty: 'No staff available to coordinate.',
      emptyPanel: 'No coordinator assigned.',
    },
    evaluators: {
      title: 'Experts',
      empty: 'No experts assigned to the activities.',
    },
    members: {
      participants: 'Entrepreneurs',
      team: 'Team',
      add: 'Add',
      addParticipants: 'Add participants',
      addTeam: 'Add team',
      participantsHint: 'Only founders with active Gaia access are listed.',
      teamHint: 'People from your organization.',
      searchPlaceholder: 'Search by name or email...',
      empty: 'No people available.',
      emptyParticipants: 'No participants assigned.',
      emptyTeam: 'No team assigned.',
      inviteEntrepreneur: 'Invite entrepreneur',
      inviteHint: 'Search by name or email first. Existing FoundersHub entrepreneurs keep their profile and receive Gaia access; new people receive an email invitation.',
      inviteEmail: 'Email',
      inviteFullName: 'Name',
      inviteSuccess: 'Entrepreneur invited successfully.',
      inviteError: 'The entrepreneur could not be invited.',
      addFailed: 'Could not add the person to the project.',
      removeFailed: 'Could not remove the person from the project.',
      pending: 'Pending',
    },
    participant: {
      myProjects: 'my projects',
      myProjectsSubtitle: 'The projects you take part in.',
      noProjects: 'You are not assigned to any project yet.',
      noAccess: 'Your account has no access to Gaia.',
    },
    history: {
      project: 'Project history',
      phase: 'Phase history',
    },
    sidebar: {
      dashboard: 'dashboard',
      projects: 'projects',
      meetings: 'meetings',
      contracts: 'contracts',
      budgets: 'budgets & kpis',
      programs: 'programs',
      auditLog: 'audit log',
      evaluations: 'evaluations',
    },
    dashboard: {
      title: 'gaia control panel',
      placeholder: 'Dashboard coming soon',
    },
    common: {
      comingSoon: 'Coming soon',
    },
    meetingStatus: {
      convened: 'Convened',
      pending_validation: 'Pending validation',
      no_validator: 'No validator',
      validated: 'Validated',
      cancelled: 'Cancelled',
    },
    meetings: {
      pageTitle: 'Meetings',
      subtitle: 'Follow-up meetings for your projects.',
      participantSubtitle: 'The meetings you have been convened to.',
      projectBlock: 'Meetings',
      detail: 'Meeting',
      itemType: 'meeting',
      statAll: 'Meetings',
      convene: 'Convene meeting',
      edit: 'Edit meeting',
      search: 'Search meeting or project...',
      filterProject: 'All projects',
      allProjects: 'All projects',
      filterStatus: 'All statuses',
      allStatuses: 'All statuses',
      empty: 'No meetings yet.',
      emptySearch: 'No meetings match your search.',
      participantEmpty: 'You have no meetings assigned.',
      projectEmpty: 'No meetings for this project yet.',
      projectEmptyCanConvene: 'No meetings yet. Convene the first one.',
      pendingSummary: 'Summary pending',
      project: 'Project',
      chooseProject: 'Select a project',
      title: 'Title',
      objectives: 'Objectives',
      dateTime: 'Date and time',
      pastWarning: 'The meeting will be recorded as already held; no invitation will be sent.',
      location: 'Link or place',
      attendees: 'Attendees',
      selectProjectFirst: 'Select a project to see its entrepreneurs.',
      noMembers: 'This project has no entrepreneurs assigned.',
      membersError: "The project's team could not be loaded.",
      requiredFields: 'Fill in project, attendees, title, objectives and date and time to convene the meeting.',
      noAttendeesWarning: 'With no attendees the meeting will be left with no validator and nobody will be able to validate it.',
      noValidatorHint: 'This meeting has no entrepreneur with an active account who could validate it. Edit the convocation to add one.',
      summary: 'Summary',
      summaryPlaceholder: 'Write down what was discussed in the meeting...',
      summaryMetadata: 'Written by',
      unknownAuthor: 'user not available',
      saveError: 'The meeting could not be saved.',
      summaryError: 'The summary could not be saved.',
      cancelError: 'The meeting could not be cancelled.',
      cancelAction: 'Cancel',
      validateError: 'The meeting could not be validated.',
      noSummary: 'No summary yet.',
      saveAndNotify: 'Save and notify the participants',
      saveSummary: 'Save summary',
      requestValidation: 'Request validation',
      validate: 'Validate meeting',
      validateConfirmTitle: 'Validate meeting',
      validateNeedsSummary: 'The organizer must add a summary before you can validate the meeting.',
      validateConfirmDescription: 'You confirm the meeting took place and that the summary reflects what was discussed. It is kept as evidence and cannot be undone.',
      validatedAt: 'Meeting validated by',
      cancelConfirmTitle: 'Cancel meeting',
      cancelConfirmDescription: 'The meeting will be recorded as cancelled and the summoned entrepreneurs will be notified.',
      loadError: 'The meeting could not be loaded.',
      notAvailable: 'Meeting not available.',
      summarySaved: 'Summary saved.',
      summarySavedValidationRequested: 'Summary saved. The attendees have been asked to validate the meeting.',
      noCalendarSyncHint: 'Gaia does not receive calendar replies: if the convocation changes or is accepted there, it has to be reflected here. The entrepreneur\'s validation confirms the meeting took place, and is kept as evidence.',
      validatorsTitle: 'Can validate it',
      validatorsNone: 'No entrepreneur with an active account can validate it yet.',
      pendingValidationCount_one: '{{count}} summary pending validation',
      pendingValidationCount_other: '{{count}} summaries pending validation',
    },
  },

  people: {
    profile: {
      title: 'people',
      manageAccount: 'Manage account',
    },
    sections: {
      details: 'details',
      cv: 'CV',
      gaiaProjects: 'projects',
      gaiaDeliverables: 'deliverables',
      gaiaMeetings: 'meetings',
      foundershubApplication: 'application',
      foundershubOpportunities: 'opportunities',
      foundershubApplications: 'applications',
    },
    details: {
      editTitle: 'Edit details',
    },
    gaia: {
      projectsEmpty: 'There are no projects of this person you can see.',
      deliverablesEmpty: 'There are no deliverables assigned to this person you can see.',
      meetingsEmpty: 'There are no meetings of this person you can see.',
      seats: {
        coordinator: 'coordinator',
        evaluator: 'expert',
        team: 'team',
      },
    },
    foundershub: {
      openApplication: 'Open application review',
      opportunitiesEmpty: 'There are no open opportunities of this person you can see.',
      applicationsEmpty: 'There are no applications of this person you can see.',
    },
  },

  // Organization
  users: {
    title: 'users & permissions',
    errors: {
      hasGaiaEvidence: "This user can't be deleted: they submitted deliverables or accepted documents in a gaia project, and that record must be kept. Deactivate the account instead.",
      alreadyMemberWithRole: "This person is already in your organization with another role. Inviting doesn't change a role: use «change role» in Team.",
    },
    myProfileTitle: 'my profile',
    subtitle: 'Manage staff roles and access permissions',
    stats: {
      total: 'total staff',
      admins: 'admins',
      staff: 'program staff',
    },
    you: 'you',
    viewProfile: 'View Profile',
    editPermissions: 'Edit Role & Permissions',
    editPermissionsTitle: 'Edit Role & Permissions',
    editPermissionsDesc: 'Update role and access for {{name}}',
    sendReset: 'Send Password Reset',
    sendResetSuccess: 'Password reset email sent to {{email}}',
    sendResetError: 'Failed to send password reset email',
    resendInvite: 'Resend Invitation',
    resendInviteSuccess: 'Invitation re-sent to {{email}}',
    resendInviteError: 'Failed to resend invitation',
    role: 'role',
    permissions: 'permissions',
    adminSuperuser: 'Admins have full platform access and bypass all scope checks.',
    save: 'Save',
    cancel: 'Cancel',
    saving: 'Saving...',
    noUsers: 'No staff users found',
    detail: {
      basicInfo: 'basic info',
      security: 'security',
      username: 'username',
      email: 'email',
      edit: 'Edit',
      saveInfo: 'Save',
      saveInfoSuccess: 'User info updated',
      saveInfoError: 'Failed to update user info',
      savePermsSuccess: 'Permissions updated',
      savePermsError: 'Failed to update permissions',
      sendResetBtn: 'Send Reset Link',
      sendResetDesc: 'Send a password reset email to {{email}}',
      notFound: 'User not found',
      platformAccess: 'platform access',
      noPlatformAccess: 'no products granted yet',
    },
  },

  superadmin: {
    sidebar: {
      organizations: 'organizations',
      users: 'users & permissions',
      roles: 'roles & access',
    },
    orgs: {
      title: 'organizations',
      subtitle: 'Manage customer organizations and their tool access',
      create: 'New organization',
      creating: 'Creating...',
      createTitle: 'Create organization',
      createDesc: 'Set up a new customer organization with tool access.',
      createSuccess: 'Organization "{{name}}" created',
      createError: 'Failed to create organization',
      empty: 'No organizations yet',
      notFound: 'Organization not found',
      tools: 'tools & access',
      members: 'members',
      enabled: 'enabled',
      disabled: 'disabled',
      featuresSaved: 'Tool access updated',
      featuresSaveError: 'Failed to update tool access',
      enabledRoles: 'assignable roles',
      rolesSaved: 'Assignable roles updated',
      rolesSaveError: 'Failed to update assignable roles',
      noRolesEnabled: 'No roles enabled',
      invitePlatform: 'platform',
      noPlatformsEnabled: 'No platforms enabled',
      invite: 'Invite user',
      inviting: 'Inviting...',
      inviteTitle: 'Invite user',
      inviteDesc: 'Create a new user and add them to {{org}}. A setup email will be sent.',
      inviteSent: 'Invite sent to {{email}}',
      inviteError: 'Failed to invite user',
      noMembers: 'No members yet',
      fields: {
        name: 'name',
        slug: 'slug',
        features: 'tools',
      },
    },
    users: {
      subtitle: 'Platform-wide staff roles and access control',
    },
    allUsers: {
      title: 'all users',
      stats: {
        total: 'total',
        entrepreneurs: 'entrepreneurs',
        staff: 'staff',
        active: 'active',
        pending: 'pending',
        disabled: 'disabled',
      },
      filters: {
        search: 'Search by name or email...',
        role: 'All Roles',
        state: 'All States',
        clear: 'Clear filters',
      },
      roleLabels: {
        entrepreneur: 'Entrepreneur',
        superadmin: 'Superadmin',
        orgAdmin: 'Org Admin',
        staff: 'All Staff',
      },
      stateLabels: {
        active: 'Active',
        pending: 'Pending',
        disabled: 'Disabled',
      },
      perPage: 'per page',
      table: {
        empty: 'No users found',
      },
      pagination: {
        showing: 'Showing {{from}}–{{to}} of {{total}}',
      },
      deleteSuccess: 'User "{{name}}" deleted',
      deleteError: 'Failed to delete user',
    },
  
    roles: {
      saved: 'Saved',
      saveError: 'Failed to save',
      title: 'roles & access',
      subtitle: 'Choose which resources each role can view and edit. Drives the navbar and route access.',
      viewAllNote: 'This role has the view_all/edit_all scope, so it can see and edit every non-superadmin resource regardless of these toggles. The toggles below still control the superadmin area.',
      save: 'Save changes',
      unsaved: 'unsaved changes',
    },},

  expert: {
    sidebar: {
      committees: 'committees',
    },
  
    onboarding: {
      ndaError: 'Could not record acknowledgement.',
      profileError: 'Could not save profile.',
      passwordTooShort: 'Password must be at least 8 characters',
      passwordMismatch: 'Passwords do not match',
      completeError: 'Could not complete onboarding.',
      invalidToken: 'Invalid or expired link',
      invalidTokenDesc: 'Please ask your organization to resend the invite.',
      backToLogin: 'Back to login',
      ndaTitle: 'Non-disclosure agreement',
      ndaDesc: 'Please review and acknowledge the NDA to continue.',
      ndaCheckbox: 'I acknowledge and agree to the NDA.',
      continue: 'Continue',
      profileTitle: 'Your details',
      firstName: 'First name',
      lastName: 'Last name',
      sectors: 'Sectors',
      passwordTitle: 'Set your password',
      password: 'Password',
      confirmPassword: 'Confirm password',
      finish: 'Finish',
      successTitle: 'You\'re all set',
      successDesc: 'Your account is active. Log in to view your committees.',
      goToLogin: 'Go to login',
    },},

  mentor: {
    onboarding: {
      title: 'Set your password',
      subtitle: 'Activate your expert account for {{email}}',
      newPassword: 'Password',
      confirmPassword: 'Confirm password',
      submit: 'Activate account',
      submitError: 'Could not activate your account.',
      passwordTooShort: 'Password must be at least 8 characters',
      passwordMismatch: 'Passwords do not match',
      invalidToken: 'Invalid or expired link',
      invalidTokenDesc: 'Please ask your organization to resend the invite.',
      backToLogin: 'Back to login',
      successTitle: 'You\'re all set',
      successDesc: 'Your account is active. Log in to view your projects.',
    },
  },

  org: {
    sidebar: {
      dashboard: 'dashboard',
      team: 'team',
      platformTerminus: 'terminus',
      platformFoundershub: "founder's hub",
      platformGaia: 'gaia',
      locations: 'locations',
      sources: 'sources',
    },
    platform: {
      nav: 'organization',
      title: '{{product}} organization',
      subtitle: 'Product entitlement and platform-specific settings for {{product}}',
      products: {
        terminus: 'terminus',
        foundershub: "founder's hub",
        gaia: 'gaia',
      },
      settings: {
        entitlement: 'product',
        entitlementDesc: 'Whether this organization is entitled to {{product}}',
        enabled: 'enabled',
        notEnabled: 'not enabled',
        organization: 'organization id',
        organizationDesc: 'Every member belongs to exactly one organization',
        managedNote: 'Product entitlements are managed by a superadmin. Membership and roles are managed here, per product.',
        disable: 'disable',
        disableSuccess: 'access disabled',
        disableError: 'could not disable access',
        reactivate: 'reactivate',
        reactivateSuccess: 'access reactivated',
        reactivateError: 'could not reactivate access',
        grant: 'grant access',
        grantSuccess: 'access granted',
        grantError: 'could not grant access',
      },
    },
    dashboard: {
      title: 'organization',
      subtitle: 'Manage your team, permissions, and expert accounts',
      stats: {
        totalAdmins: 'admins',
        totalExperts: 'experts',
        activeExperts: 'active',
        pendingExperts: 'pending',
      },
      currentUser: 'your account',
      role: 'Role',
      scopes: 'Scopes',
      quickLinks: 'quick links',
      manageTeam: 'manage team',
      manageTeamDesc: 'View admin users, edit roles and permissions',
    },
    locations: {
      title: 'locations',
      subtitle: 'Meeting places used when scheduling committees',
      add: 'add location',
      empty: 'No locations yet. Add one to schedule committee meetings.',
      name: 'name',
      namePlaceholder: 'e.g. HQ Boardroom',
      address: 'address',
      addressPlaceholder: 'Street, city (optional)',
      onlineUrl: 'online URL',
      onlineUrlPlaceholder: 'https://meet… (optional)',
      editTitle: 'edit location',
      addTitle: 'new location',
      save: 'save',
      cancel: 'cancel',
      deleteTitle: 'delete location?',
      deleteDescription: 'This location will no longer be selectable for committees.',
      delete: 'delete',
      created: 'Location created',
      updated: 'Location updated',
      deleted: 'Location deleted',
      saveError: 'Could not save location',
      deleteError: 'Could not delete location',
    
      mapField: 'find on map',
      mapHint: 'Search, click the map, or drag the pin to set the exact spot.',
      mapLabel: 'Location map',
      searchPlaceholder: 'Search for a place or address',
      mapDisabled: 'Map search is unavailable — set VITE_AZURE_MAPS_CLIENT_ID to enable it. You can still enter the address manually.',},
    team: {
      title: 'team',
      subtitle: 'Manage your team and see their access at a glance',
      stats: {
        total: 'total',
        experts: 'experts',
        admins: 'admins',
        members: 'members',
        entrepreneurs: 'entrepreneurs',
        pending: 'pending',
      },
      roles: {
        admin: 'admin',
        member: 'member',
        entrepreneur: 'entrepreneur',
      },
      filters: { all: 'all' },
      allPlatforms: 'all platforms',
      items: 'people',
      searchPlaceholder: 'Search by name, email, or role...',
      empty: 'No team members match these filters',
      you: 'you',
      pending: 'pending',
      // Identity + eligibility, never a permission (§8.3) — an EXPERT with a
      // profile, shown as derived, read-only state. "committee expert", not
      // bare "expert": disambiguates from a Gaia activity expert (evaluator)
      // on-screen, since the two share the word but are different things.
      expertBadge: 'committee expert',
      editSectors: 'edit sectors',
      editSectorsTitle: 'edit sectors',
      editSectorsDesc: "Sectors this committee expert is knowledgeable in — {{name}}'s eligibility, not a permission.",
      sectorsSaved: 'Sectors updated',
      sectorsError: 'Failed to update sectors',
      // A read-only count with a link to the object that holds it — the
      // assignment IS the permission, and it is created or removed where the
      // object lives (the committee, the project), never here (§8.3).
      grantsCount: '{{count}} grant',
      grantsCount_plural: '{{count}} grants',
      editRole: 'change role',
      alreadyMemberWithRole: "{{name}} is already {{role}} in your organization. Inviting doesn't change a role: use «change role».",
      editRoleTitle: 'change role',
      editRoleDesc: "Update {{name}}'s role in this organization",
      roleSaved: 'Role updated',
      roleError: 'Failed to update role',
      save: 'Save',
      cancel: 'Cancel',
      saving: 'Saving...',
      noAdmins: 'No admin users found',
      errorLoading: 'Error loading admin users: {{message}}',
      invite: 'invite user',
      inviteTitle: 'Invite a team member',
      inviteDesc: 'Invite an admin, member, or entrepreneur. Each person receives the appropriate access and onboarding flow.',
      inviteEmail: 'Email',
      inviteFullName: 'Full name',
      inviteFullNamePlaceholder: 'Jane Doe',
      invitePlatform: 'Product',
      inviteRole: 'Role',
      inviteSubmit: 'Send invitation',
      inviteSending: 'Sending...',
      inviteSuccess: 'Invitation sent to {{email}}',
      inviteError: 'Failed to invite user',
      remove: 'remove from organization',
      removeTitle: 'Remove team member',
      removeDesc: 'Remove {{name}} ({{email}}) from your organization? This permanently deletes the user account and revokes their access.',
      removeConfirm: 'Remove user',
      removing: 'Removing...',
      removeSuccess: '{{name}} removed from organization',
      removeError: 'Failed to remove user',
      resendInvite: 'resend invite',
      resendInviteSuccess: 'Invitation re-sent to {{email}}',
      resendInviteError: 'Failed to resend invitation',
      revokeAccess: 'remove from platform',
      revokeAccessTitle: 'Revoke platform access',
      revokeAccessDesc:
        'Revoke {{name}} access to {{platforms}}? The account is not deleted: they keep their profile and any access granted by another organization, and you can grant this one back later.',
      revokeAccessConfirm: 'Revoke access',
      revokeAccessSuccess: '{{name}} no longer has access to {{platforms}}',
      revokeAccessError: 'Failed to revoke access',
    },
  },

  // All Applications View
  allApplications: {
      projectsLabel: 'Projects',
      avatarAlt: 'Avatar',
    title: 'Entrepreneurs',
    subtitle: 'Review and manage entrepreneurs through their journey',
    errorLoading: 'Error loading applications: {{message}}',
    status: {
      approved: 'Approved',
      approvedDesc: 'Application approved, user can access platform',
      rejected: 'Rejected',
      rejectedDesc: 'Application was not approved',
      readyForReview: 'Ready for Review',
      readyForReviewDesc: 'Passed pre-score, awaiting admin review',
      postScoring: 'Post-Scoring',
      postScoringDesc: 'Admin notes added, post-score evaluation complete',
      failedPreScore: 'Failed Pre-Score',
      failedPreScoreDesc: 'First pre-score attempt failed, can retry',
      processing: 'Processing',
      processingDesc: 'AI pre-score evaluation in progress',
      onboarding: 'Onboarding',
      onboardingDesc: 'Completing profile form',
      linkedInPending: 'LinkedIn Pending',
      linkedInPendingDesc: 'Awaiting LinkedIn profile import',
      defaultDesc: 'Status pending',
    },
    stats: {
        approvalRate: 'Approval Rate',
      total: 'Total',
      totalTooltip: 'Total applications in the system',
      pendingReview: 'Pending Review',
      pendingReviewTooltip: 'Applications ready for admin review',
      processing: 'Processing',
      processingTooltip: 'Applications in progress (onboarding, AI evaluation)',
      approved: 'Approved',
      approvedTooltip: 'Successfully approved entrepreneurs',
      rejected: 'Rejected',
      rejectedTooltip: 'Applications that were not approved',
    },
    filters: {
      all: 'All Applications',
      pendingReview: 'Pending Review',
      processing: 'Processing',
      approved: 'Approved',
      rejected: 'Rejected',
      statusFilter: 'Status Filter',
      clearFilters: 'Clear filters',
      searchPlaceholder: 'Search by name or email...',
      applicationsCount: '{{count}} applications',
    },
    emptyState: {
      noApplications: 'No applications found',
    },
    scores: {
      pre: 'Pre',
      post: 'Post',
      preScore: 'Pre-Score',
      postScore: 'Post-Score',
      excellent: 'Excellent candidate',
      good: 'Good potential',
      needsReview: 'Needs review',
    },
    journey: {
      title: 'Journey',
      journeyTitle: 'Application Journey',
      linkedin: 'LinkedIn',
      profile: 'Profile',
      preScore: 'Pre-Score',
      review: 'Review',
      decision: 'Decision',
    },
    legend: {
      scoreIndicator: 'Score indicator',
      journeyProgress: 'Journey progress',
    },
    actions: {
      viewApplication: 'View Application',
      viewFullProfile: 'View Full Profile',
    },
  },

  // Founders Hub Dashboard
  foundersHubDashboard: {
    title: "Founder's Hub Dashboard",
    subtitle: 'Real-time insights into entrepreneur applications and metrics',
    backToTerminus: 'Back to Terminus',
    loadingMetrics: 'Loading metrics...',
    failedToLoad: 'Failed to load dashboard metrics',
    noDate: 'No date',
    metrics: {
      totalApplications: 'Total Applications',
      pendingReview: 'Pending Review',
      approvalRate: 'Approval Rate',
      avgProcessingTime: 'Avg Processing Time',
      thisWeek: 'this week',
    },
    charts: {
      applicationTimeline: 'Application Timeline (Last 7 Days)',
      dailyBreakdown: 'Daily breakdown of application statuses',
      statusDistribution: 'Status Distribution',
      currentBreakdown: 'Current application breakdown',
      preScoreDistribution: 'Pre-Score Distribution (Approved)',
      scoreRanges: 'Score ranges for approved entrepreneurs',
      recentActivity: 'Recent Activity',
      latestUpdates: 'Latest application updates',
    },
    pendingApplications: 'Pending Applications',
    applicationsAwaitingReview: 'Applications awaiting review',
  },

  // Profile Review
  profileReview: {
    loading: 'Loading your profile...',
    title: 'Review Your Profile',
    subtitle: "We've imported your information from LinkedIn. Please review and submit for approval.",
    linkedInVerified: 'LinkedIn Verified',
    profileInformation: 'Profile Information',
    importedFromLinkedIn: 'Information imported from your LinkedIn profile',
    firstName: 'First Name',
    lastName: 'Last Name',
    emailAddress: 'Email Address',
    professionalHeadline: 'Professional Headline',
    accountCreated: 'Account Created',
    notAvailable: 'Not available',
    readyToSubmit: 'Ready to Submit?',
    reviewDescription: "Your profile will be reviewed by our team. This typically takes 24-48 hours. You'll receive an email once approved.",
    refreshProfile: 'Refresh Profile',
    submitting: 'Submitting...',
    submitForReview: 'Submit for Review',
    privacyNotice: 'By submitting your profile, you consent to our processing of your data in accordance with our Privacy Policy. You can update or delete your information at any time after approval.',
  },

  // User Menu
  userMenu: {
    profile: 'Profile',
    settings: 'Settings',
    signingOut: 'Signing out...',
    signOut: 'Sign Out',
    notSignedIn: 'Not signed in',
    signIn: 'Sign In',
    guest: 'Guest',
  },

  // Login
  login: {
    signUpLink: 'Sign up',
    founderPortal: 'Founder Portal',
    poweredByVess: 'powered by vess.',
    contactSupport: 'Contact support at',
    entrepreneurLink: 'Are you an entrepreneur? Log in here',
    entrepreneurHint: 'Are you an entrepreneur?',
    entrepreneurHintLink: 'Sign in from the entrepreneur login.',
    errors: {
      invalidCredentials: 'Incorrect email or password.',
      accountNotActivated: "Your account isn't activated yet. Use the invitation link we emailed you to set your password, or request a password reset.",
      accountDisabled: 'This account has been disabled. Contact your organization if you think this is a mistake.',
      emailNotVerified: "Your email isn't verified yet. Check your inbox for the verification link we sent, or request a new one from the login page.",
      ssoOnly: 'This account was created with SSO. Please sign in with your provider.',
      passwordLoginDisabled: 'Password sign-in is not available for this kind of account. Use the sign-in method your invitation pointed you to.',
      noAccount: 'You don\'t have an account with that LinkedIn. Sign up first.',
      alreadyRegistered: 'You already have an account with that LinkedIn. Sign in.',
      signupClosed: 'LinkedIn sign-up is not open on this platform.',
      oauthFailed: 'We could not complete the LinkedIn sign-in. Please try again.',
    },
    forEntrepreneurs: 'For entrepreneurs and startup founders',
    invalidConfiguration: 'Invalid configuration',
    continueWith: 'Continue with {{provider}}',
    or: 'or',
    email: 'Email',
    password: 'Password',
    logIn: 'Log In',
    lastUsed: 'last used',
    forgotPassword: 'Forgot your password?',
    forgotPasswordDialog: {
      title: 'Reset password',
      desc: 'Tell us the address you sign in with and we will email you a link to set a new password.',
      submit: 'Send link',
      confirmTitle: 'Check your email',
      confirmDesc: 'If the address is on file we have sent you a reset link. If it does not arrive in a few minutes, check your spam folder.',
    },
  },

  // Common
  // Project Detail (match card labels)
  projectDetail: {
    scoreDistribution: {
      topFit: 'Top Fit',
      strong: 'Strong',
      potential: 'Potential',
      low: 'Low',
    },
    matchCard: {
      unknownEntrepreneur: 'Unknown Entrepreneur',
      yearsExperience: '{{years}}+ yrs',
      applied: 'Applied',
      matched: 'Matched',
      sector: 'Sector',
      role: 'Role',
      keywords: 'Keywords',
    },
  },
  markdownViewer: {
    downloadMarkdown: 'Markdown (.md)',
    downloadPdf: 'PDF (.pdf)',
  },

  // Application Profile Page
  applicationProfile: {
    backButton: 'Applications',
    noHeadline: 'No headline',
    preScore: 'Pre-Score',
    postScore: 'Post-Score',
    aiEvaluationSummary: 'AI Evaluation Summary',
    strengths: 'Strengths',
    concerns: 'Concerns',
    adminReview: 'Admin Review',
    discPersonality: 'DISC Personality',
    selectType: 'Select type...',
    none: 'None',
    notAssigned: 'Not assigned',
    notes: 'Notes',
    addEvaluationNotes: 'Add evaluation notes...',
    noNotesYet: 'No notes yet',
    networkCounts: 'LinkedIn Network',
    connections: 'Connections',
    followers: 'Followers',
    connectionsPlaceholder: 'e.g. 500',
    followersPlaceholder: 'e.g. 1200',
    notSet: 'not set',
    networkCountsRequired: 'Connections and followers are required and must be greater than 0.',
    profileSummary: 'Profile Summary',
    fullProfile: 'Full Profile',
    experience: 'Experience',
    education: 'Education',
    status: {
      approved: 'Approved',
      rejected: 'Rejected',
      readyForReview: 'Ready for Review',
      postScoring: 'Post-Scoring',
      aiProcessing: 'AI Processing',
    },
    score: {
      pending: 'Pending',
      excellent: 'Excellent',
      good: 'Good',
      needsReview: 'Needs Review',
    },
    notesSections: {
      validacion: 'General assessment',
      perfil: 'Entrepreneurial profile',
      trayectoria: 'Professional track record',
      red: 'Network and social validation',
    },
  },

  // Candidate Action Buttons
  candidateActions: {
    adminNotes: 'Admin Notes',
    approve: 'Approve',
    approveTooltip: 'Approve Application',
    alreadyApproved: 'Application is already approved',
    reject: 'Reject',
    rejectTooltip: 'Reject Application',
    alreadyRejected: 'Application is already rejected',
    retriggerPreScore: 'Retrigger Pre-Score',
    retriggerPostScore: 'Retrigger Post-Score',
    retriggerLinkedin: 'Re-scrape LinkedIn',
    resetToInitial: 'Reset to Initial State',
    notesDialog: {
      title: 'Admin Notes',
      description: 'Add evaluation notes for this application. These notes are required before post-scoring.',
      notesLabel: 'Notes',
      notesPlaceholder: 'Add your notes about this application...',
      categories: {
        validacion: 'General Assessment',
        validacionPlaceholder: 'Interview observations, soft skills, motivation, red flags...',
        perfil: 'Entrepreneurial Profile',
        perfilPlaceholder: 'Entrepreneurial credentials, fundraising, observed exits...',
        trayectoria: 'Career Trajectory',
        trayectoriaPlaceholder: 'Career trajectory, achievements, verified progression...',
        red: 'Network & Social Validation',
        redPlaceholder: 'Network quality, visibility, references...',
      },
      discLabel: 'DISC Personality Type',
      discPlaceholder: 'Select a DISC personality type...',
      none: 'None',
      cancel: 'Cancel',
      saving: 'Saving...',
      saveNotes: 'Save Notes',
    },
    rejectDialog: {
      title: 'Reject Application',
      description: 'Please provide a reason for rejecting this application. This feedback will be stored with the application.',
      reasonLabel: 'Rejection Reason',
      reasonPlaceholder: 'Provide feedback for the applicant...',
      cancel: 'Cancel',
      rejectApplication: 'Reject Application',
    },
    resetDialog: {
      title: 'Reset Application to Initial State',
      description: 'This will reset the application to PENDING_LINKEDIN_PARSE state and clear all data including:',
      linkedInData: 'LinkedIn profile data',
      scores: 'Pre-score and post-score evaluations',
      adminNotes: 'Admin notes',
      history: 'All approval/rejection history',
      cannotUndo: 'This action cannot be undone.',
      cancel: 'Cancel',
      resetting: 'Resetting...',
      resetApplication: 'Reset Application',
    },
  },

  // Application Sidebar (AI Evaluation)
  applicationSidebar: {
    preScoreTitle: 'Pre-Score AI Evaluation',
    postScoreTitle: 'Post-Score AI Evaluation',
    preScoreNotCompleted: 'Pre-score evaluation not yet completed.',
    preScoreHint: 'Run the pre-score evaluation to see AI insights.',
    postScoreNotCompleted: 'Post-score evaluation not yet completed.',
    postScoreHint: 'Add admin notes and DISC assessment to trigger post-score evaluation.',
    overallScore: 'Overall Score',
    executiveSummary: 'Executive Summary',
    subScoresBreakdown: 'Sub-scores Breakdown',
    formula: 'Formula: ',
    extractedFeatures: 'Extracted Features',
    yearsExperience: 'Years Experience:',
    avgTenure: 'Avg Tenure:',
    founderMonths: 'Founder Months:',
    promotions: 'Promotions:',
    keywordsDensity: 'Keywords Density:',
    activityItems: 'Activity Items:',
    keyStrengths: 'Key Strengths',
    areasOfConcern: 'Areas of Concern',
    finalScore: 'Final Score',
    finalRecommendation: 'Final Recommendation',
    executiveSummaryUpdated: 'Executive Summary (Updated)',
    keyStrengthsFinal: 'Key Strengths (Final Assessment)',
    areasOfConcernFinal: 'Areas of Concern (Final Assessment)',
    finalReasoning: 'Final Reasoning',
    nextSteps: 'Next Steps',
    adminNotesAddressed: 'Admin Notes Addressed',
    personalityTraits: 'Personality Traits:',
    appearanceAssessment: 'Appearance Assessment:',
    preScoreConsideration: 'Pre-Score Consideration:',
  },

  tour: {
    tooltipReplay: 'Replay guided tour',
  },

  auth: {
    noAccessYet: 'Your account does not have access to any section yet. Ask an administrator to assign you a project.',
    resetPassword: {
      title: 'set new password',
      subtitle: 'Setting password for {{email}}',
      newPassword: 'new password',
      confirmPassword: 'confirm password',
      submit: 'Set Password',
      passwordMismatch: 'Passwords do not match',
      passwordTooShort: 'Password must be at least 8 characters',
      submitError: 'Failed to set password. Please try again.',
      invalidToken: 'invalid or expired link',
      invalidTokenDesc: 'This password reset link is invalid or has already been used.',
      backToLogin: 'back to login',
      successTitle: 'password updated',
      successDesc: 'Your password has been set. You can now log in.',
      usedToken: 'this link was already used',
      expiredInvitation: 'your invitation has expired',
      expiredInvitationDesc: 'Ask for a new one and we will send it to the same email.',
      requestNewInvitation: 'request a new invitation',
      reissueNotSent: 'We could not send you a new invitation. Ask your organization to invite you again.',
      reissueError: 'We could not request a new invitation. Please try again.',
      reissuedTitle: 'invitation sent',
      reissuedDesc: 'We have sent you a new invitation. Check your inbox and use the new link.',
    },
    invitation: {
      title: 'create your password',
      staffSubtitle: 'You were invited as {{email}}. Create your password to get in.',
      submit: 'create password',
      invalidDesc: 'This invitation link is not valid or no longer active. If you already created your password, log in.',
      usedDesc: 'Your account is already active. Log in.',
      createdTitle: 'password created',
      createdDesc: 'You can now log in with your email and password.',
    },
    wrapper: {
      loading: 'Loading...',
      redirecting: 'Redirecting to login...',
      accessForbidden: 'Access Forbidden',
      noPermission: "You don't have permission to access this page.",
      returnToDashboard: 'Return to Dashboard',
      featureNotAvailable: 'Feature Not Available',
      noOrgAccess: 'Your organization does not have access to this tool.',
      authError: 'Authentication Error',
    },
  },
  monitoredSources: {
    title: 'monitored sources',
    runSyncNow: 'run sync now',
    description: 'RSS/Atom feeds read once per day to discover emerging startups and surface news about your dealflow startups.',
    noSources: 'No sources yet',
    active: 'active',
    paused: 'paused',
    pause: 'Pause',
    activate: 'Activate',
    remove: 'Remove',
    namePlaceholder: 'Name (e.g. TechCrunch)',
    urlPlaceholder: 'https://example.com/feed.xml',
    add: 'add',
    toasts: {
      sourceAdded: 'Source added',
      addFailed: 'Failed to add source',
      updateFailed: 'Failed to update source',
      sourceRemoved: 'Source removed',
      removeFailed: 'Failed to remove source',
      syncJobTitle: 'Source monitoring sync',
      syncStarted: 'Sync started',
      syncFailed: 'Failed to start sync',
    },
  },

  orgSourcesPage: {
    title: 'sources.',
    subtitle: 'RSS/Atom feeds your organization monitors to feed the dealflow.',
  },

  entrepreneurProfilePage: {
    noHeadline: 'No headline provided',
    linkedin: 'LinkedIn',
    preScore: 'Pre-Score',
    postScore: 'Post-Score',
    tabs: {
      linkedin: 'LinkedIn Profile',
      preScore: 'Pre-Score Analysis',
      postScore: 'Post-Score Analysis',
    },
    linkedinNotAvailable: 'LinkedIn profile data not available.',
    preScoreCard: {
      title: 'Pre-Score AI Evaluation',
      description: 'Initial assessment based on LinkedIn profile data',
    },
    postScoreCard: {
      title: 'Post-Score AI Evaluation',
      description: 'Final assessment after admin review and DISC analysis',
    },
    preScoreTab: {
      notCompleted: 'Pre-score evaluation not yet completed.',
      runToSeeInsights: 'Run the pre-score evaluation to see AI insights.',
      overallScore: 'Overall Score',
      executiveSummary: 'Executive Summary',
      subScoresBreakdown: 'Sub-scores Breakdown',
      formula: 'Formula: ',
      extractedFeatures: 'Extracted Features',
      yearsExperience: 'Years Experience:',
      avgTenure: 'Avg Tenure:',
      founderMonths: 'Founder Months:',
      promotions: 'Promotions:',
      keywordsDensity: 'Keywords Density:',
      activityItems: 'Activity Items:',
      keyStrengths: 'Key Strengths',
      areasOfConcern: 'Areas of Concern',
    },
    postScoreTab: {
      notCompleted: 'Post-score evaluation not yet completed.',
      addNotesToTrigger: 'Add admin notes and DISC assessment to trigger post-score evaluation.',
      finalScore: 'Final Score',
      finalRecommendation: 'Final Recommendation',
      executiveSummaryUpdated: 'Executive Summary (Updated)',
      keyStrengthsFinal: 'Key Strengths (Final Assessment)',
      areasOfConcernFinal: 'Areas of Concern (Final Assessment)',
      finalReasoning: 'Final Reasoning',
      nextSteps: 'Next Steps',
      adminNotesAddressed: 'Admin Notes Addressed',
      personalityTraits: 'Personality Traits:',
      appearanceAssessment: 'Appearance Assessment:',
      preScoreConsideration: 'Pre-Score Consideration:',
    },
  },

  applicationProfilePage: {
    title: 'Application Profile',
    noHeadline: 'No headline provided',
    linkedinProfile: 'LinkedIn Profile',
    preScore: 'Pre-Score',
    postScore: 'Post-Score',
    preScoreSummary: 'Pre-Score Summary',
    adminReview: {
      title: 'Admin Review',
      description: 'Notes and assessments from admin review',
    },
    discAssessment: 'DISC Assessment',
    selectDiscType: 'Select a DISC personality type...',
    none: 'None',
    noDiscYet: 'No DISC assessment added yet. Click Edit to add assessment.',
    adminNotes: 'Admin Notes',
    noNotesYet: 'No admin notes added yet. Click Edit to add notes.',
  },

  entrepreneurProfilePageNew: {
    breadcrumbEntrepreneurs: 'entrepreneurs',
    breadcrumbProfile: 'profile',
    entrepreneurFallback: 'Entrepreneur',
    present: 'Present',
    viewApplication: 'View Application',
    about: 'About',
    experience: 'Experience',
    current: 'Current',
    education: 'Education',
    skills: 'Skills',
    languages: 'Languages',
    certifications: 'Certifications',
    view: 'View',
    created: 'Created {{time}}',
    updated: 'Updated {{time}}',
  },

  adminDashboard: {
    title: 'Admin Dashboard',
    welcomeBack: 'Welcome back, {{name}}',
    refresh: 'Refresh',
    signOut: 'Sign Out',
    signingOut: 'Signing out...',
    stats: {
      pendingApplications: 'Pending Applications',
      awaitingReview: 'Awaiting review',
      adminUser: 'Admin User',
      administrator: 'Administrator',
      status: 'Status',
      online: 'Online',
      systemOperational: 'System operational',
    },
    pendingSection: {
      title: 'Pending Entrepreneur Applications',
      description: 'Review and approve or reject entrepreneur applications',
    },
  },

  commandPalette: {
    startTypingAll: 'Start typing to search',
    startTypingEntrepreneurs: 'Start typing to search entrepreneurs',
    filterByTypeHint: 'filter by type',
    searchByIdHint: 'search by ID',
    filterByTypeHeading: 'Filter by type',
    search: 'Search',
    also: 'also',
    searchByIdOrSlug: 'Search by ID or slug',
    enterIdOrSlugDesc: 'Enter a UUID or slug to find specific entities',
    typeAtLeast2: 'Type at least 2 characters to search',
    searching: 'Searching...',
    noResultsFor: 'No results found for "{{query}}"',
    recent: 'Recent',
    placeholderEntrepreneurs: 'Search entrepreneurs...',
    placeholderEverything: 'Search everything...',
    placeholderFiltered: 'Search {{types}}...',
    placeholderIdOrSlug: 'Enter ID or slug...',
    types: {
      marketInsights: 'Market Insights',
      opportunities: 'Opportunities',
      solutions: 'Solutions',
      startups: 'Startups',
      projects: 'Projects',
      committees: 'Committees',
      entrepreneurs: 'Entrepreneurs',
      applications: 'Applications',
    },
  },

  emoi: {
    title: 'emoi',
    subtitle: 'in-app assistant',
    open: 'Open emoi',
    close: 'Close emoi',
    placeholder: 'Ask emoi to do something…',
    send: 'Send',
    contextLabel: 'context',
    pending: 'Thinking…',
    toolCall: 'action',
    empty: 'Ask emoi to add an opportunity to this committee, or to manage Terminus without leaving this page.',
    errorPrefix: 'Could not reach emoi',
    clear: 'Clear conversation',
  },
  explanations: {
    solutionScore: {
      title: 'How the solution score is calculated',
      content: `The **solution score** is a number from **0 to 100**. It is not produced directly by the AI — it is calculated **deterministically** on the server as the sum of six weighted dimensions.

| Dimension | Max | What it measures |
|---|---|---|
| Line fit | 30 | Fit with the solution line and its KPI |
| Startup fit | 30 | Match of product, technology and business model |
| Data feasibility | 15 | Availability and IT feasibility of the required data |
| TTV / payback | 10 | Time-to-value ≤ 90 days and payback ≤ 12 months |
| Transferability | 5 | Reuse potential across other lines |
| Business model / ICP | 10 | Pricing and operating fit with the ideal customer profile |

Each dimension is scored up to its maximum, then all six are added together for the final score out of 100. A higher score means a stronger, more feasible solution.`,
    },
    startupMatch: {
      title: 'How the startup match score is calculated',
      content: `The **startup match** score is a number from **0 to 100** measuring how well a startup fits this specific solution. It is a fixed weighted average of three dimensions, each rated 0–10 by the AI against the solution and then scaled to 0–100.

| Dimension | Weight | What it measures |
|---|---|---|
| Problem fit | 45% | How well the startup addresses the opportunity's problem |
| Solution fit | 45% | How well the startup's technology matches the solution |
| Transferability | 10% | How transferable the startup is to EU / USA markets |

Only startups scoring **70 or above** are shown as matches. A higher score means a stronger, more transferable fit.`,
    },
    startupSearchRanking: {
      title: 'How startup search ranking works',
      content: `Startup search runs entirely against **PostgreSQL**, not the vector database. A startup exists in Postgres the moment it is created, whereas its Qdrant vector only appears after 2DS + one-pager generation finishes — so searching Postgres is what makes a brand-new startup findable immediately.

**Where it looks**

Each startup has a weighted full-text document combining:

| Field | Weight |
|---|---|
| name, Chinese name | **A** (highest) |
| alternate name, slug | **B** |
| 2D problem/market narrative | **C** |
| 2D business/execution narrative, sector | **D** (lowest) |

A name match therefore outranks a match found only in the one-pager body.

**How results are ordered**

1. **Exact name match** first — typing \`openai\` puts *openai* above *openai holdings*.
2. **Name starts with your query** next — \`rob\` surfaces *Roborock* before a startup merely mentioning robotics in its profile.
3. **Relevance score** (\`ts_rank\`) for everything else — documents matching more of your terms rank higher.
4. **Most recently updated** breaks any remaining tie, so ordering is always stable.

**The score**

The 0–1 number on each row is the relevance score, normalised against the best hit in that result set — so the top result is always 1.00 and the rest are relative to it. Rows shown without a score come from a plain sector listing rather than a ranked search.

**Notes**

- Terms are OR-ed with prefix matching, so partial and multi-word queries both work.
- Chinese names are additionally matched by substring, because full-text tokenisation cannot segment CJK text.
- The sector toggle above filters results server-side; switch it off to search every sector.`,
    },
    marketInsightMatch: {
      title: 'How the market-insight match score is calculated',
      content: `Matching a market insight to startups happens in **two stages**, which is why the score above and the scores below can look different from each other.

**1. Semantic search (per dimension)**

The market insight's headline and problem summary are embedded and searched in Qdrant against every startup's profile, along two separate dimensions:

| Dimension | What it measures |
|---|---|
| Problem & market | How closely the startup's problem/market fits the market insight |
| Business & execution | How closely the startup's business model and execution fit |

Each dimension keeps its best raw cosine-similarity score — that's what's shown per dimension below.

**2. AI reranking (final score)**

The top candidates from step 1 are then re-ranked by Cohere against the full research query, producing the **final match score** shown above the startup's name. This is a different relevance model than the raw semantic search, so it can rate a startup higher or lower than its raw per-dimension scores alone would suggest.

If reranking wasn't available when this match was created, the final score falls back to the raw semantic score instead — and for older matches made before per-dimension scoring existed, only a single undifferentiated raw score is stored below.`,
    },
  },

  createMarketInsightPage: {
    editTitle: 'Edit Market Insight',
    title: 'Create New Market Insight',
    editSubtitle: 'Update your market insight, upload documents and configure analysis filters.',
    subtitle: 'Set up your market insight with documents and analysis filters.',
    basicInfo: 'Basic Information',
    uploadDocuments: 'Upload Documents',
    analysisFilters: 'Analysis Filters',
    save: 'Save',
    saveAsDraft: 'Save as Draft',
  },
  sectorPicker: {
    placeholder: 'Select sector',
    title: 'Select sector',
    search: 'Search sectors...',
  },
  renameDialog: {
    title: 'Edit name',
    description: 'Set a new name and save.',
  },
  validation: {
    required: 'This field is required',
    minLength: 'Please provide more detail',
  },
  opportunity: {
    untitled: 'Untitled opportunity',
    score: 'Opportunity score',
    linked_to_committee: 'Linked to Committee',
    permanently_linked_to_committee: 'Permanently linked to Committee',
    unlink_will_devalidate: 'Unlink and move back to draft',
    link_locked_hint: 'Link is permanent once the committee decides.',
    link_locked: 'Locked',
    unlink_committee_title: 'Unlink from Committee?',
    unlink_committee_description: 'This will remove the committee link and move the opportunity back to Draft. You can resubmit it later from a different committee.',
    unlink_and_devalidate: 'Unlink and move to Draft',
    submitted_for_validation: 'Submitted for validation in {{name}}',
    submit_failed: 'Could not submit opportunity for validation',
    same_sector_committees: 'Same-sector committees ({{sector}}) eligible to review this opportunity.',
    eligible_committees: 'Committees eligible to review this opportunity.',
    submit_for_validation_title: 'Submit for Validation',
    search_committees: 'Search committees...',
    no_available_committees: 'No committees available for this opportunity sector.',
    no_matching_committees: 'No committees match your search.',
  },
  fileDropzone: { validation: {"rejected":"Rejected files: {{files}}.","singleFile":"Select only one file.","fileTooLarge":"The file exceeds the {{max_mb}} MB size limit. Allowed extensions: {{allowed_extensions}}.","unsupportedFileType":"File extension not allowed. Allowed extensions: {{allowed_extensions}}. Maximum size: {{max_mb}} MB."} },
  gaiaDocuments: {
    loading: "Loading documents...",
    loadError: "Documents could not be loaded.",
    retry: "Retry",
    noMatches: "No documents match your search.",
    noPending: "There are no documents pending acceptance.",
    noFilteredResults: "No documents match these filters.",
    detail: {"unavailableTitle":"Document not available","unavailable":"The document may have been deleted or is not shared with you","loadError":"The document could not be loaded.","backToDocuments":"Back to documents","backToProfile":"Back to my profile"},
    delete: {"title":"Delete document","acceptedWarning":"“{{document}}”, version {{version}}, was accepted by {{name}} on {{date}} (Madrid). If you delete it, that record of acceptance will no longer be accessible.","error":"The document could not be deleted. You can retry."},
    sidebar: 'Documents', title: 'documents', subtitle: 'Documentation shared with gaia people and projects.',
    itemType: 'document', search: 'Search document, person, email or project...', perPage: 'Documents per page:', empty: 'There are no documents in your scope yet.',
    stats: { total: 'Total', pending: 'Pending', accepted: 'Accepted' }, status: { no_acceptor: 'No acceptor', pending: 'Pending acceptance', accepted: 'Accepted' },
    target: { all: 'All destinations', user: 'Person', project: 'Project' }, category: { all: 'All categories', contract: 'Contract', support_material: 'Support material', other: 'Other' },
    filter: { no_acceptor: 'No acceptor', all: 'Any acceptance', pending: 'Pending acceptance', accepted: 'Accepted', not_required: 'No acceptance' },
    uploader: { all: 'Any uploader' },
    sort: { newest: 'Newest first', oldest: 'Oldest first', name_asc: 'Name A–Z', name_desc: 'Name Z–A' },
    actions: { view: 'View', download: 'Download', newVersion: 'New version', reassign: 'Reassign', history: 'History' },
    fields: { target: 'Destination', selectTarget: 'Select person or project', file: 'File', name: 'Name', category: 'Category', description: 'Description', requiresAcceptance: 'Requires express acceptance by the user', requiresAcceptanceHint: 'The recipient or the first project participant must confirm it.' },
    upload: { title: 'Upload document', action: 'Upload document', submit: 'Save document', error: 'The document could not be uploaded.' },
    fileDropzone: { dropActive: 'Drop the file here', dropIdle: 'Drag and drop the file here', browse: 'or browse your device', formats: 'Accepted formats', files: 'Files', remove: 'Remove file' },
    targetPicker: { loadError: 'Destinations could not be loaded.', title: 'Select destination', description: 'Only people and projects within your scope are shown.', search: 'Search people or projects...', empty: 'No destinations are available.' },
    version: { title: 'Upload new version', submit: 'Save new version', confirmTitle: 'Confirm new version', confirm: 'Upload and invalidate acceptance', invalidationWarning: 'The current version was accepted by {{name}} on {{date}}. That acceptance will be invalidated and the document will be pending acceptance again.' },
    reassign: { title: 'Reassign document', description: 'Reassignment does not create a new version.', current: 'Current destination', select: 'Select new destination' },
    history: { timezone: 'Madrid', downloadVersion: 'Download version {{version}}', noEvents: 'There is no activity yet.', noVersions: 'There are no versions yet.', title: 'Document history', versions: 'Versions', events: 'Activity', system: 'System' },
    event: { created: 'Document created', assigned: 'Document assigned', accepted: 'Document accepted', acceptance_invalidated: 'Previous acceptance invalidated', version_uploaded: 'New version uploaded', reassigned: 'Destination reassigned', deleted: 'Document deleted' },
    project: { title: 'Documents', description: 'Material and documentation assigned to this project.', empty: 'This project has no documents yet.' },
    profile: { userTitle: 'Documents', userEmpty: 'There are no documents addressed to this person that you can see.', selfEmpty: 'No documents have been shared with you yet.' },
    preview: { unavailable: 'This format cannot be previewed inside gaia. Download the file to review its contents.' },
    accept: { versionChanged: 'The document version has changed. Review the current version and confirm your acceptance again.', error: 'The document could not be accepted.', noAcceptor: 'There are no active participants who can accept this document. It remains pending and can be reassigned.', acceptedBy: 'Accepted by {{name}}', checkbox: 'I have read and expressly accept the contents of this document', action: 'Accept document', confirmTitle: 'Confirm acceptance', confirmDescription: 'You are accepting “{{name}}”, version {{version}}. Your express acceptance will be recorded in the history.', confirm: 'Confirm acceptance' },
  },
  clients: {
    list: {
      title: 'Clients',
      subtitle: 'Client companies your organization works with',
      newClient: 'New Client',
      searchPlaceholder: 'Search clients...',
      count_one: '{{count}} client',
      count_other: '{{count}} clients',
      empty: 'No clients yet',
      errorLoading: 'Error loading clients: {{message}}',
      sectorFilter: 'Sector',
      clearFilters: 'Clear filters',
    },
    form: {
      title_create: 'New Client',
      title_edit: 'Edit Client',
      company: 'Company',
      company_placeholder: 'Company name',
      industry: 'Industry',
      industry_placeholder: 'Select an industry',
      web: 'Website',
      web_placeholder: 'https://example.com',
      contact_name: 'Contact Name',
      contact_name_placeholder: 'Contact name',
      contact_role: 'Role',
      contact_role_placeholder: 'Contact role',
      contact_email: 'Contact Email',
      contact_email_placeholder: 'contact@example.com',
      contact_phone: 'Contact Phone',
      contact_phone_placeholder: 'Contact phone number',
    },
    detail: {
      itemType: 'client',
    },
    project: {
      title: 'clients',
      empty: 'No clients attached to this project.',
      addClient: 'Add client',
      detach: 'Detach',
      attachedCount_one: '{{count}} client attached',
      attachedCount_other: '{{count}} clients attached',
      attachFailed: 'Failed to attach client',
      picker: {
        title: 'Attach client',
        description: 'Search existing clients or create a new one to attach to this project.',
        searchPlaceholder: 'Search clients...',
        noClients: 'No clients yet.',
        noMatches: 'No clients match your search.',
        addNew: 'New client',
        sectorFilterLabel: 'Filter by sector',
      },
    },
  },
};
